"use client";

import Section from "@/components/section";

export default function Privacy() {
  return (
    <Section className="bg-background py-24">
      <div
        className=" [&_h2]:first-letter:uppercase max-w-3xl [&_h3]:mb-4 [&_a]:break-words  [&_h3]:text-xl [&_h3]:font-semibold mx-auto [&_ol]:list-decimal [&_ol]:pl-6 [&_ul]:pl-6 [&_ul]:list-disc [&_ul]:space-y-2 [&_ul]:mb-4 [&_ol]:space-y-2 [&_ol]:mb-4 [&_a]:text-primary [&_a:hover]:underline"
        data-content
      >
        <h1 className="text-4xl font-bold mb-8">Privacy Policy</h1>
        <h2 className="text-2xl font-semibold mb-4" id="m716">Preamble</h2>
        <p className="mb-4">
          With the following privacy policy we would like to inform you which
          types of your personal data (hereinafter also abbreviated as &quot;data&quot;)
          we process for which purposes and in which scope. The privacy
          statement applies to all processing of personal data carried out by
          us, both in the context of providing our services and in particular on
          our websites, in mobile applications and within external online
          presences, such as our social media profiles (hereinafter collectively
          referred to as &quot;online services&quot;).
        </p>
        <p className="mb-4">The terms used are not gender-specific.</p>
        <p className="mb-4">Last Update: 12. May 2025</p>
        <h2 className="text-2xl font-semibold mb-4">Table of contents</h2>
        <ul className="index index">
          <li>
            <a className="index-link" href="#m716">
              Preamble
            </a>
          </li>
          <li>
            <a className="index-link" href="#m3">
              Controller
            </a>
          </li>
          <li>
            <a className="index-link" href="#mOverview">
              Overview of processing operations
            </a>
          </li>
          <li>
            <a className="index-link" href="#m2427">
              Relevant legal bases
            </a>
          </li>
          <li>
            <a className="index-link" href="#m27">
              Security Precautions
            </a>
          </li>
          <li>
            <a className="index-link" href="#m25">
              Transmission of Personal Data
            </a>
          </li>
          <li>
            <a className="index-link" href="#m24">
              International data transfers
            </a>
          </li>
          <li>
            <a className="index-link" href="#m12">
              General Information on Data Retention and Deletion
            </a>
          </li>
          <li>
            <a className="index-link" href="#m10">
              Rights of Data Subjects
            </a>
          </li>
          <li>
            <a className="index-link" href="#m317">
              Business services
            </a>
          </li>
          <li>
            <a className="index-link" href="#m3575">
              Providers and services used in the course of business
            </a>
          </li>
          <li>
            <a className="index-link" href="#m225">
              Provision of online services and web hosting
            </a>
          </li>
          <li>
            <a className="index-link" href="#m134">
              Use of Cookies
            </a>
          </li>
          <li>
            <a className="index-link" href="#m104">
              Blogs and publication media
            </a>
          </li>
          <li>
            <a className="index-link" href="#m182">
              Contact and Inquiry Management
            </a>
          </li>
          <li>
            <a className="index-link" href="#m391">
              Communication via Messenger
            </a>
          </li>
          <li>
            <a className="index-link" href="#m2555">
              Artificial Intelligence (AI)
            </a>
          </li>
          <li>
            <a className="index-link" href="#m735">
              Video Conferences, Online Meetings, Webinars and Screen-Sharing
            </a>
          </li>
          <li>
            <a className="index-link" href="#m29">
              Cloud Services
            </a>
          </li>
          <li>
            <a className="index-link" href="#m17">
              Newsletter and Electronic Communications
            </a>
          </li>
          <li>
            <a className="index-link" href="#m263">
              Web Analysis, Monitoring and Optimization
            </a>
          </li>
          <li>
            <a className="index-link" href="#m264">
              Online Marketing
            </a>
          </li>
          <li>
            <a className="index-link" href="#m136">
              Profiles in Social Networks (Social Media)
            </a>
          </li>
          <li>
            <a className="index-link" href="#m328">
              Plugins and embedded functions and content
            </a>
          </li>
          <li>
            <a className="index-link" href="#m1360">
              Processing of data in the context of employment relationships
            </a>
          </li>
          <li>
            <a className="index-link" href="#m15">
              Changes and Updates
            </a>
          </li>
          <li>
            <a className="index-link" href="#m42">
              Terminology and Definitions
            </a>
          </li>
        </ul>
        <h2 className="text-2xl font-semibold mb-4" id="m3">Controller</h2>
        <p className="mb-4">
          Savages Corp Ltd Cyprus
          <br />
          C/O Advassion Ltd.
          <br />
          Griva Digeni 42
          <br />
          1080 Lefkosia
          <br />
          Cyprus
        </p>
        <p className="mb-4">
          E-mail address:
          <a href="mailto:contact@savagescorp.com">contact@savagescorp.com</a>
        </p>
        <h2 className="text-2xl font-semibold mb-4" id="mOverview">Overview of processing operations</h2>
        <p className="mb-4">
          The following table summarises the types of data processed, the
          purposes for which they are processed and the concerned data subjects.
        </p>
        <h3>Categories of Processed Data</h3>
        <ul className="list-disc pl-6 space-y-2 mb-4 index list-disc pl-6 space-y-2 mb-4 index">
          <li>Inventory data.</li>
          <li>Employee Data.</li>
          <li>Payment Data.</li>
          <li>Contact data.</li>
          <li>Content data.</li>
          <li>Contract data.</li>
          <li>Usage data.</li>
          <li>Meta, communication and process data.</li>
          <li>Social data.</li>
          <li>Images and/ or video recordings.</li>
          <li>Audio recordings.</li>
          <li>Contact Information (Facebook).</li>
          <li>Event Data (Facebook).</li>
          <li>Log data.</li>
          <li>Performance and behavioural data.</li>
          <li>Working hours data.</li>
          <li>Salary data.</li>
        </ul>
        <h3>Special Categories of Data</h3>
        <ul className="list-disc pl-6 space-y-2 mb-4 index list-disc pl-6 space-y-2 mb-4 index">
          <li>Health Data.</li>
          <li>Religious or philosophical beliefs.</li>
          <li>Trade union membership.</li>
        </ul>
        <h3>Categories of Data Subjects</h3>
        <ul className="list-disc pl-6 space-y-2 mb-4 index list-disc pl-6 space-y-2 mb-4 index">
          <li>Service recipients and clients.</li>
          <li>Employees.</li>
          <li>Prospective customers.</li>
          <li>Communication partner.</li>
          <li>Users.</li>
          <li>Members.</li>
          <li>Business and contractual partners.</li>
          <li>Persons depicted.</li>
          <li>Third parties.</li>
        </ul>
        <h3>Purposes of Processing</h3>
        <ul className="list-disc pl-6 space-y-2 mb-4 index list-disc pl-6 space-y-2 mb-4 index">
          <li>
            Provision of contractual services and fulfillment of contractual
            obligations.
          </li>
          <li>Communication.</li>
          <li>Security measures.</li>
          <li>Direct marketing.</li>
          <li>Web Analytics.</li>
          <li>Targeting.</li>
          <li>Office and organisational procedures.</li>
          <li>Remarketing.</li>
          <li>Conversion tracking.</li>
          <li>Clicktracking.</li>
          <li>Affiliate Tracking.</li>
          <li>A/B Tests.</li>
          <li>Organisational and Administrative Procedures.</li>
          <li>Feedback.</li>
          <li>Heatmaps.</li>
          <li>Marketing.</li>
          <li>Profiles with user-related information.</li>
          <li>Provision of our online services and usability.</li>
          <li>Establishment and execution of employment relationships.</li>
          <li>Information technology infrastructure.</li>
          <li>Public relations.</li>
          <li>Business processes and management procedures.</li>
          <li>Artificial Intelligence (AI).</li>
        </ul>
        <h2 className="text-2xl font-semibold mb-4" id="m2427">Relevant legal bases</h2>
        <p className="mb-4">
          <strong>Relevant legal bases according to the GDPR: </strong>In the
          following, you will find an overview of the legal basis of the GDPR on
          which we base the processing of personal data. Please note that in
          addition to the provisions of the GDPR, national data protection
          provisions of your or our country of residence or domicile may apply.
          If, in addition, more specific legal bases are applicable in
          individual cases, we will inform you of these in the data protection
          declaration.
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index list-disc pl-6 space-y-2 mb-4 index">
          <li>
            <strong>Consent (Article 6 (1) (a) GDPR)</strong> - The data subject
            has given consent to the processing of his or her personal data for
            one or more specific purposes.
          </li>
          <li>
            <strong>
              Performance of a contract and prior requests (Article 6 (1) (b)
              GDPR)
            </strong>
            - Performance of a contract to which the data subject is party or in
            order to take steps at the request of the data subject prior to
            entering into a contract.
          </li>
          <li>
            <strong>
              Compliance with a legal obligation (Article 6 (1) (c) GDPR)
            </strong>
            - Processing is necessary for compliance with a legal obligation to
            which the controller is subject.
          </li>
          <li>
            <strong>Legitimate Interests (Article 6 (1) (f) GDPR)</strong> - the
            processing is necessary for the protection of the legitimate
            interests of the controller or a third party, provided that the
            interests, fundamental rights, and freedoms of the data subject,
            which require the protection of personal data, do not prevail.
          </li>
          <li>
            <strong>
              Healthcare, occupational and social security processing of special
              categories of personal data (Article 9 (2)(h) GDPR)
            </strong>
            - processing is necessary for the purposes of preventive or
            occupational medicine, for the assessment of the working capacity of
            the employee, medical diagnosis, the provision of health or social
            care or treatment or the management of health or social care systems
            and services on the basis of Union or Member State law or pursuant
            to contract with a health professional.
          </li>
        </ul>
        <p className="mb-4">
          <strong>
            Reference to the applicability of the GDPR and the Swiss DPA:
          </strong>
          These privacy policy serves both to provide information pursuant to
          the Swiss Federal Act on Data Protection (FADP) and the General Data
          Protection Regulation (GDPR). For this reason, we ask you to note that
          due to the broader spatial application and comprehensibility, the
          terms used in the GDPR are applied. In particular, instead of the
          terms used in the Swiss FADP such as &quot;processing&quot; of &quot;personal data&quot;,
          &quot;predominant interest&quot;, and &quot;particularly sensitive personal data&quot;,
          the terms used in the GDPR, namely &quot;processing&quot; of &quot;personal data&quot;, as
          well as &quot;legitimate interest&quot; and &quot;special categories of data&quot; are
          used. However, the legal meaning of these terms will continue to be
          determined according to the Swiss FADP within its scope of
          application.
        </p>
        <h2 className="text-2xl font-semibold mb-4" id="m27">Security Precautions</h2>
        <p className="mb-4">
          We take appropriate technical and organisational measures in
          accordance with the legal requirements, taking into account the state
          of the art, the costs of implementation and the nature, scope, context
          and purposes of processing as well as the risk of varying likelihood
          and severity for the rights and freedoms of natural persons, in order
          to ensure a level of security appropriate to the risk.
        </p>
        <p className="mb-4">
          The measures include, in particular, safeguarding the confidentiality,
          integrity and availability of data by controlling physical and
          electronic access to the data as well as access to, input,
          transmission, securing and separation of the data. In addition, we
          have established procedures to ensure that data subjects&apos; rights are
          respected, that data is erased, and that we are prepared to respond to
          data threats rapidly. Furthermore, we take the protection of personal
          data into account as early as the development or selection of
          hardware, software and service providers, in accordance with the
          principle of privacy by design and privacy by default.
        </p>
        <p className="mb-4">
          Securing online connections through TLS/SSL encryption technology
          (HTTPS): To protect the data of users transmitted via our online
          services from unauthorized access, we employ TLS/SSL encryption
          technology. Secure Sockets Layer (SSL) and Transport Layer Security
          (TLS) are the cornerstones of secure data transmission on the
          internet. These technologies encrypt the information that is
          transferred between the website or app and the user&apos;s browser (or
          between two servers), thereby safeguarding the data from unauthorized
          access. TLS, as the more advanced and secure version of SSL, ensures
          that all data transmissions conform to the highest security standards.
          When a website is secured with an SSL/TLS certificate, this is
          indicated by the display of HTTPS in the URL. This serves as an
          indicator to users that their data is being securely and encryptedly
          transmitted.
        </p>
        <h2 className="text-2xl font-semibold mb-4" id="m25">Transmission of Personal Data</h2>
        <p className="mb-4">
          In the course of processing personal data, it may happen that this
          data is transmitted to or disclosed to other entities, companies,
          legally independent organizational units, or individuals. Recipients
          of this data may include service providers tasked with IT duties or
          providers of services and content that are integrated into a website.
          In such cases, we observe the legal requirements and particularly
          conclude relevant contracts or agreements that serve to protect your
          data with the recipients of your data.
        </p>
        <h2 className="text-2xl font-semibold mb-4" id="m24">International data transfers</h2>
        <p className="mb-4">
          Data Processing in Third Countries: If we transfer data to a third
          country (i.e., outside the European Union (EU) or the European
          Economic Area (EEA)), or if this occurs in the context of using
          third-party services or the disclosure or transfer of data to other
          individuals, entities, or companies (which becomes apparent either
          from the postal address of the respective provider or when explicitly
          mentioned in the privacy policy regarding data transfer to third
          countries), this is always done in accordance with legal requirements.
        </p>
        <p className="mb-4">
          For data transfers to the USA, we primarily rely on the Data Privacy
          Framework (DPF), which has been recognized as a secure legal framework
          by the EU Commission&apos;s adequacy decision of July 10, 2023.
          Additionally, we have concluded Standard Contractual Clauses with the
          respective providers, which comply with the EU Commission&apos;s
          requirements and establish contractual obligations to protect your
          data.
        </p>
        <p className="mb-4">
          This dual safeguard ensures comprehensive protection of your data: The
          DPF serves as the primary level of protection, while the Standard
          Contractual Clauses act as an additional security measure. Should any
          changes occur within the DPF framework, the Standard Contractual
          Clauses will serve as a reliable fallback option. This ensures that
          your data remains adequately protected even in the event of political
          or legal changes.
        </p>
        <p className="mb-4">
          For individual service providers, we will inform you whether they are
          certified under the DPF and if Standard Contractual Clauses are in
          place. The list of certified companies and further information about
          the DPF can be found on the U.S. Department of Commerce&apos;s website at
          <a href="https://www.dataprivacyframework.gov/" target="_blank">
            https://www.dataprivacyframework.gov/.
          </a>
        </p>
        <p className="mb-4">
          For data transfers to other third countries, appropriate safeguards
          apply, particularly Standard Contractual Clauses, explicit consent, or
          legally required transfers. Information on third-country transfers and
          applicable adequacy decisions can be found in the information provided
          by the EU Commission:
          <a
            href="https://commission.europa.eu/law/law-topic/data-protection/international-dimension-data-protection_en"
            target="_blank"
          >
            https://commission.europa.eu/law/law-topic/data-protection/international-dimension-data-protection_en.
          </a>
        </p>
        <p className="mb-4">
          We will inform you which of our service providers are certified under
          the Data Privacy Framework as part of our data protection notices.
        </p>
        <h2 className="text-2xl font-semibold mb-4" id="m12">General Information on Data Retention and Deletion</h2>
        <p className="mb-4">
          We delete personal data that we process in accordance with legal
          regulations as soon as the underlying consents are revoked or no
          further legal bases for processing exist. This applies to cases where
          the original purpose of processing is no longer applicable or the data
          is no longer needed. Exceptions to this rule exist if statutory
          obligations or special interests require a longer retention or
          archiving of the data.
        </p>
        <p className="mb-4">
          In particular, data that must be retained for commercial or tax law
          reasons, or whose storage is necessary for legal prosecution or
          protection of the rights of other natural or legal persons, must be
          archived accordingly.
        </p>
        <p className="mb-4">
          Our privacy notices contain additional information on the retention
          and deletion of data specifically applicable to certain processing
          processes.
        </p>
        <p className="mb-4">
          In cases where multiple retention periods or deletion deadlines for a
          date are specified, the longest period always prevails.
        </p>
        <p className="mb-4">
          If a period does not expressly start on a specific date and lasts at
          least one year, it automatically begins at the end of the calendar
          year in which the event triggering the period occurred. In the case of
          ongoing contractual relationships in the context of which data is
          stored, the event triggering the deadline is the time at which the
          termination or other termination of the legal relationship takes
          effect.
        </p>
        <p className="mb-4">
          Data that is no longer stored for its originally intended purpose but
          due to legal requirements or other reasons are processed exclusively
          for the reasons justifying their retention.
        </p>
        <h2 className="text-2xl font-semibold mb-4" id="m10">Rights of Data Subjects</h2>
        <p className="mb-4">
          Rights of the Data Subjects under the GDPR: As data subject, you are
          entitled to various rights under the GDPR, which arise in particular
          from Articles 15 to 21 of the GDPR:
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index list-disc pl-6 space-y-2 mb-4 index">
          <li>
            <strong>
              Right to Object: You have the right, on grounds arising from your
              particular situation, to object at any time to the processing of
              your personal data which is based on letter (e) or (f) of Article
              6(1) GDPR, including profiling based on those provisions. Where
              personal data are processed for direct marketing purposes, you
              have the right to object at any time to the processing of the
              personal data concerning you for the purpose of such marketing,
              which includes profiling to the extent that it is related to such
              direct marketing.
            </strong>
          </li>
          <li>
            <strong>Right of withdrawal for consents:</strong> You have the
            right to revoke consents at any time.
          </li>
          <li>
            <strong>Right of access:</strong> You have the right to request
            confirmation as to whether the data in question will be processed
            and to be informed of this data and to receive further information
            and a copy of the data in accordance with the provisions of the law.
          </li>
          <li>
            <strong>Right to rectification:</strong> You have the right, in
            accordance with the law, to request the completion of the data
            concerning you or the rectification of the incorrect data concerning
            you.
          </li>
          <li>
            <strong>
              Right to Erasure and Right to Restriction of Processing:
            </strong>
            In accordance with the statutory provisions, you have the right to
            demand that the relevant data be erased immediately or,
            alternatively, to demand that the processing of the data be
            restricted in accordance with the statutory provisions.
          </li>
          <li>
            <strong>Right to data portability:</strong> You have the right to
            receive data concerning you which you have provided to us in a
            structured, common and machine-readable format in accordance with
            the legal requirements, or to request its transmission to another
            controller.
          </li>
          <li>
            <strong>Complaint to the supervisory authority:</strong> In
            accordance with the law and without prejudice to any other
            administrative or judicial remedy, you also have the right to lodge
            a complaint with a data protection supervisory authority, in
            particular a supervisory authority in the Member State where you
            habitually reside, the supervisory authority of your place of work
            or the place of the alleged infringement, if you consider that the
            processing of personal data concerning you infringes the GDPR.
          </li>
        </ul>
        <h2 className="text-2xl font-semibold mb-4" id="m317">Business services</h2>
        <p className="mb-4">
          We process data of our contractual and business partners, e.g.
          customers and interested parties (collectively referred to as
            &quot;contractual partners&quot;) within the context of contractual and
          comparable legal relationships as well as associated actions and
          communication with the contractual partners or pre-contractually, e.g.
          to answer inquiries.
        </p>
        <p className="mb-4">
          We process this data in order to fulfill our contractual obligations.
          These include, in particular, the obligations to provide the agreed
          services, any update obligations and remedies in the event of warranty
          and other service disruptions. In addition, we process the data to
          protect our rights and for the purpose of administrative tasks
          associated with these obligations and company organization.
          Furthermore, we process the data on the basis of our legitimate
          interests in proper and economical business management as well as
          security measures to protect our contractual partners and our business
          operations from misuse, endangerment of their data, secrets,
          information and rights (e.g. for the involvement of
          telecommunications, transport and other auxiliary services as well as
          subcontractors, banks, tax and legal advisors, payment service
          providers or tax authorities). Within the framework of applicable law,
          we only disclose the data of contractual partners to third parties to
          the extent that this is necessary for the aforementioned purposes or
          to fulfill legal obligations. Contractual partners will be informed
          about further forms of processing, e.g. for marketing purposes, within
          the scope of this privacy policy.
        </p>
        <p className="mb-4">
          Which data are necessary for the aforementioned purposes, we inform
          the contracting partners before or in the context of the data
          collection, e.g. in online forms by special marking (e.g. colors),
          and/or symbols (e.g. asterisks or the like), or personally.
        </p>
        <p className="mb-4">
          We delete the data after expiry of statutory warranty and comparable
          obligations, i.e. in principle after expiry of 4 years, unless the
          data is stored in a customer account or must be kept for legal reasons
          of archiving. The statutory retention period for documents relevant
          under tax law as well as for commercial books, inventories, opening
          balance sheets, annual financial statements, the instructions required
          to understand these documents and other organizational documents and
          accounting records is ten years and for received commercial and
          business letters and reproductions of sent commercial and business
          letters six years. The period begins at the end of the calendar year
          in which the last entry was made in the book, the inventory, the
          opening balance sheet, the annual financial statements or the
          management report was prepared, the commercial or business letter was
          received or sent, or the accounting document was created, furthermore
          the record was made or the other documents were created.
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>Processed data types:</strong> Inventory data (For example,
            the full name, residential address, contact information, customer
            number, etc.); Payment Data (e.g. bank details, invoices, payment
            history); Contact data (e.g. postal and email addresses or phone
            numbers). Contract data (e.g. contract object, duration, customer
            category).
          </li>
          <li>
            <strong>Data subjects:</strong> Service recipients and clients;
            Prospective customers. Business and contractual partners.
          </li>
          <li>
            <strong>Purposes of processing:</strong> Provision of contractual
            services and fulfillment of contractual obligations; Communication;
            Office and organisational procedures; Organisational and
            Administrative Procedures. Business processes and management
            procedures.
          </li>
          <li>
            <strong>Retention and deletion:</strong> Deletion in accordance with
            the information provided in the section &quot;General Information on Data
            Retention and Deletion&quot;.
          </li>
          <li className="">
            <strong>Legal Basis:</strong> Performance of a contract and prior
            requests (Article 6 (1) (b) GDPR); Compliance with a legal
            obligation (Article 6 (1) (c) GDPR). Legitimate Interests (Article 6
            (1) (f) GDPR).
          </li>
        </ul>
        <p className="mb-4">
          <strong>
            Further information on processing methods, procedures and services
            used:
          </strong>
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>Agency Services: </strong>We process the data of our
            customers within the scope of our contractual services, which may
            include e.g. conceptual and strategic consulting, campaign planning,
            software and design development / consulting or maintenance,
            implementation of campaigns and processes, handling, server
            administration, data analysis / consulting services and training
            services;
            <span className="">
              <strong>Legal Basis:</strong> Performance of a contract and prior
              requests (Article 6 (1) (b) GDPR).
            </span>
          </li>
          <li>
            <strong>Coaching: </strong>We process the data of our clients as
            well as prospects and other contractors or business partners
            (collectively referred to as &quot;clients&quot;) in order to provide them
            with our services. The processes carried out within the framework
            and for the purposes of coaching include: initiating contact and
            communication with clients, needs analysis to determine suitable
            coaching measures, planning and conducting coaching sessions,
            documenting coaching progress, capturing and managing
            client-specific information and data, scheduling and organising
            appointments, providing coaching materials and resources, invoicing
            and payment management, post-processing and follow-up of coaching
            sessions, quality assurance and feedback processes.
            <br />
            The processed data, its nature, scope, purpose, and the necessity of
            its processing are determined by the underlying contractual
            relationship with the client.
            <br />
            Insofar as it is necessary for fulfilling our contract, protecting
            vital interests or legally required, or if there is consent from the
            clients, we disclose or transfer the clients&apos; data in compliance
            with professional legal requirements to third parties or agents such
            as authorities, billing centers as well as in the field of IT,
            office or comparable services;
            <span className="">
              <strong>Legal Basis:</strong> Performance of a contract and prior
              requests (Article 6 (1) (b) GDPR).
            </span>
          </li>
          <li>
            <strong>Consulting: </strong>We process the data of our clients as
            well as prospects and other commissioning parties or contractual
            partners (collectively referred to as &quot;clients&quot;) in order to be able
            to provide our services to them. The processes that are part of and
            for the purposes of consulting include: contacting and communicating
            with clients, conducting needs and requirements analyses, planning
            and implementing consulting projects, documenting project progress
            and results, capturing and managing client-specific information and
            data, scheduling and organising appointments, providing consulting
            resources and materials, invoicing and payment management,
            post-processing and follow-up of consulting projects, quality
            assurance and feedback processes. The processed data, the nature,
            scope, purpose, and necessity of their processing are determined by
            the underlying contractual relationship with the client.
            <br />
            If it is necessary for our contract performance, for the protection
            of vital interests or legally required, or if there is consent from
            the clients, we disclose or transmit client data in compliance with
            professional legal requirements to third parties or agents such as
            authorities, subcontractors or in the field of IT, office or similar
            services;
            <span className="">
              <strong>Legal Basis:</strong> Performance of a contract and prior
              requests (Article 6 (1) (b) GDPR).
            </span>
          </li>
          <li>
            <strong>Marketing Services: </strong>We process the data of our
            customers and clients (uniformly referred to as &quot;customers&quot;) to
            offer marketing services such as market research, advertising
            campaigns, content creation, and social media management. The
            necessary information is indicated as such at the time of order
            placement and includes the details required for service provision
            and billing, as well as contact information in order to be able to
            hold any consultations. Insofar as we gain access to information
            from end customers, employees, or other persons, we process it in
            accordance with legal and contractual requirements;
            <span className="">
              <strong>Legal Basis:</strong> Performance of a contract and prior
              requests (Article 6 (1) (b) GDPR), Compliance with a legal
              obligation (Article 6 (1) (c) GDPR), Legitimate Interests (Article
              6 (1) (f) GDPR).
            </span>
          </li>
          <li>
            <strong>IT Services: </strong>We process the data of our clients as
            well as contractors to enable them to plan, implement, and support
            IT solutions and associated services. The required information is
            marked as such during the contract, project, or similar agreement
            phase and includes details necessary for service provision and
            billing, as well as contact information to facilitate any necessary
            consultations. Insofar as we gain access to information from end
            customers, employees, or other individuals, we process this in
            accordance with legal and contractual requirements.
            <br />
            <br />
            Processing processes include project management and documentation,
            which cover all phases from initial requirement analysis to project
            completion. This involves creating and managing project timelines,
            budgets, and resource allocations. Data processing also supports
            change management, where changes in the project flow are documented
            and tracked to ensure compliance and transparency.
            <br />
            <br />
            Another process is customer relationship management (CRM), which
            involves recording and analyzing customer interactions and feedback
            to improve service quality and efficiently address individual
            customer needs. Additionally, the processing process encompasses
            technical support and trouble-shooting, which includes capturing and
            handling support requests, error resolutions, and regular
            maintenance.
            <br />
            <br />
            Furthermore, reporting and performance analysis are conducted by
            capturing and evaluating performance metrics to assess the
            effectiveness of provided IT solutions continuously optimizing them.
            All these processes are aimed at ensuring high customer satisfaction
            and compliance with all relevant regulations;
            <span className="">
              <strong>Legal Basis:</strong> Performance of a contract and prior
              requests (Article 6 (1) (b) GDPR), Compliance with a legal
              obligation (Article 6 (1) (c) GDPR), Legitimate Interests (Article
              6 (1) (f) GDPR).
            </span>
          </li>
        </ul>
        <h2 className="text-2xl font-semibold mb-4" id="m3575">
          Providers and services used in the course of business
        </h2>
        <p className="mb-4">
          As part of our business activities, we use additional services,
          platforms, interfaces or plug-ins from third-party providers (in
          short, &quot;services&quot;) in compliance with legal requirements. Their use is
          based on our interests in the proper, legal and economic management of
          our business operations and internal organization.
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>Processed data types:</strong> Inventory data (For example,
            the full name, residential address, contact information, customer
            number, etc.); Payment Data (e.g. bank details, invoices, payment
            history); Contact data (e.g. postal and email addresses or phone
            numbers); Content data (e.g. textual or pictorial messages and
            contributions, as well as information pertaining to them, such as
            details of authorship or the time of creation.); Contract data (e.g.
            contract object, duration, customer category); Usage data (e.g. page
            views and duration of visit, click paths, intensity and frequency of
            use, types of devices and operating systems used, interactions with
            content and features). Meta, communication and process data (e.g. IP
            addresses, timestamps, identification numbers, involved parties).
          </li>
          <li>
            <strong>Data subjects:</strong> Service recipients and clients;
            Prospective customers. Business and contractual partners.
          </li>
          <li>
            <strong>Purposes of processing:</strong> Provision of contractual
            services and fulfillment of contractual obligations; Office and
            organisational procedures. Business processes and management
            procedures.
          </li>
          <li>
            <strong>Retention and deletion:</strong> Deletion in accordance with
            the information provided in the section &quot;General Information on Data
            Retention and Deletion&quot;.
          </li>
          <li className="">
            <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
            (f) GDPR).
          </li>
        </ul>
        <p className="mb-4">
          <strong>
            Further information on processing methods, procedures and services
            used:
          </strong>
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>QuickBooks Intuit: </strong>Accounting, invoicing, payment
            processing, payroll accounting, financial reporting, and tax
            preparation; <strong>Service provider</strong>: Intuit Ltd, 80
            Victoria Street, London SW1E 5JL, UK;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://quickbooks.intuit.com/eu/" target="_blank">
              https://quickbooks.intuit.com/eu/
            </a>
            . <strong>Privacy Policy:</strong>
            <a href="https://www.intuit.com/privacy/statement/" target="_blank">
              https://www.intuit.com/privacy/statement/
            </a>
            .
          </li>
        </ul>
        <h2 className="text-2xl font-semibold mb-4" id="m225">Provision of online services and web hosting</h2>
        <p className="mb-4">
          We process user data in order to be able to provide them with our
          online services. For this purpose, we process the IP address of the
          user, which is necessary to transmit the content and functions of our
          online services to the user&apos;s browser or terminal device.
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>Processed data types:</strong> Usage data (e.g. page views
            and duration of visit, click paths, intensity and frequency of use,
            types of devices and operating systems used, interactions with
            content and features); Meta, communication and process data (e.g. IP
            addresses, timestamps, identification numbers, involved parties).
            Log data (e.g. log files concerning logins or data retrieval or
            access times.).
          </li>
          <li>
            <strong>Data subjects:</strong> Users (e.g. website visitors, users
            of online services).
          </li>
          <li>
            <strong>Purposes of processing:</strong> Provision of our online
            services and usability; Information technology infrastructure
            (Operation and provision of information systems and technical
            devices, such as computers, servers, etc.)). Security measures.
          </li>
          <li>
            <strong>Retention and deletion:</strong> Deletion in accordance with
            the information provided in the section &quot;General Information on Data
            Retention and Deletion&quot;.
          </li>
          <li className="">
            <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
            (f) GDPR).
          </li>
        </ul>
        <p className="mb-4">
          <strong>
            Further information on processing methods, procedures and services
            used:
          </strong>
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>Provision of online offer on rented hosting space: </strong>
            For the provision of our online services, we use storage space,
            computing capacity and software that we rent or otherwise obtain
            from a corresponding server provider (also referred to as a &quot;web
            hoster&quot;);
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR).
            </span>
          </li>
          <li>
            <strong>Collection of Access Data and Log Files: </strong>Access to
            our online service is logged in the form of so-called &quot;server log
            files&quot;. Server log files may include the address and name of the
            accessed web pages and files, date and time of access, transferred
            data volumes, notification of successful retrieval, browser type
            along with version, the user&apos;s operating system, referrer URL (the
            previously visited page), and typically IP addresses and the
            requesting provider. The server log files can be used for security
            purposes, e.g., to prevent server overload (especially in the case
            of abusive attacks, known as DDoS attacks), and to ensure server
            load management and stability;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR).
            </span>
            <strong>Retention period:</strong> Log file information is stored
            for a maximum period of 30 days and then deleted or anonymized.
            Data, the further storage of which is necessary for evidence
            purposes, are excluded from deletion until the respective incident
            has been finally clarified.
          </li>
          <li>
            <strong>Raidboxes: </strong>Services in the field of the provision
            of information technology infrastructure and related services (e.g.
            storage space and/or computing capacities);
            <strong>Service provider</strong>: RAIDBOXES GmbH, Hafenstra&szlig;e
            32, 48153 M&uuml;nster, Germany;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://raidboxes.io/en/" target="_blank">
              https://raidboxes.io/en/
            </a>
            ; <strong>Privacy Policy:</strong>
            <a
              href="https://raidboxes.io/en/datenschutzerklaerung/"
              target="_blank"
            >
              https://raidboxes.io/en/datenschutzerklaerung/
            </a>
            . <strong>Data Processing Agreement:</strong>
            <a
              href="https://helpcenter.raidboxes.de/en/articles/1947634-data-processing-agreement-dpa"
              target="_blank"
            >
              https://helpcenter.raidboxes.de/en/articles/1947634-data-processing-agreement-dpa
            </a>
            .
          </li>
        </ul>
        <h2 className="text-2xl font-semibold mb-4" id="m134">Use of Cookies</h2>
        <p className="mb-4">
          The term &quot;cookies&quot; refers to functions that store information on
          users&apos; devices and read it from them. Cookies can also be used for
          different purposes, such as ensuring the functionality, security, and
          convenience of online services, as well as analyzing visitor traffic.
          We use cookies in accordance with legal regulations. If necessary, we
          obtain users&apos; consent in advance. If consent is not required, we rely
          on our legitimate interests. This applies when storing and reading
          information is essential to provide explicitly requested content and
          functions. This includes, for example, saving settings and ensuring
          the functionality and security of our online services. Consent can be
          withdrawn at any time. We clearly inform users about the scope of the
          consent and which cookies are used.
        </p>
        <p className="mb-4">
          <strong>Information on legal data protection bases:</strong> Whether
          we process personal data using cookies depends on users&apos; consent. If
          consent is given, it serves as the legal basis. Without consent, we
          rely on our legitimate interests, as outlined in this section and in
          the context of the respective services and procedures.
        </p>
        <p className="mb-4">
          <strong>Storage duration:</strong> The following types of cookies are
          distinguished based on their storage duration:
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index list-disc pl-6 space-y-2 mb-4 index">
          <li>
            <strong>Temporary cookies (also: session cookies):</strong>
            Temporary cookies are deleted at the latest after a user leaves an
            online service and closes their device (e.g., browser or mobile
            application).
          </li>
          <li>
            <strong>Permanent cookies:</strong> Permanent cookies remain stored
            even after the device is closed. For example, the login status can
            be saved, and preferred content can be displayed directly when the
            user revisits a website. Additionally, the user data collected with
            cookies may be used for audience measurement. Unless we provide
            explicit information to users about the type and storage duration of
            cookies (e.g., when obtaining consent), users should assume that
            these are permanent and may have a storage duration of up to two
            years.
          </li>
        </ul>
        <p className="mb-4">
          <strong>
            General information on withdrawal and objection (opt-out):
          </strong>
          Users can withdraw their consent at any time and also object to the
          processing according to legal regulations, including through the
          privacy settings of their browser.
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>Processed data types:</strong> Meta, communication and
            process data (e.g. IP addresses, timestamps, identification numbers,
            involved parties).
          </li>
          <li>
            <strong>Data subjects:</strong> Users (e.g. website visitors, users
            of online services).
          </li>
          <li className="">
            <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
            (f) GDPR). Consent (Article 6 (1) (a) GDPR).
          </li>
        </ul>
        <p className="mb-4">
          <strong>
            Further information on processing methods, procedures and services
            used:
          </strong>
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>Processing Cookie Data on the Basis of Consent: </strong>We
            implement a consent management solution that obtains users&apos; consent
            for the use of cookies or for the processes and providers mentioned
            within the consent management framework. This procedure is designed
            to solicit, log, manage, and revoke consents, particularly regarding
            the use of cookies and similar technologies employed to store, read
            from, and process information on users&apos; devices. As part of this
            procedure, user consents are obtained for the use of cookies and the
            associated processing of information, including specific processing
            and providers named in the consent management process. Users also
            have the option to manage and withdraw their consents. Consent
            declarations are stored to avoid repeated queries and to provide
            proof of consent according to legal requirements. The storage is
            carried out server-side and/or in a cookie (so-called opt-in cookie)
            or by means of comparable technologies in order to associate the
            consent with a specific user or their device.If no specific details
            about the providers of consent management services are provided, the
            following general notes apply: The duration of consent storage is up
            to two years. A pseudonymous user identifier is created, which is
            stored along with the time of consent, details on the scope of
            consent (e.g., relevant categories of cookies and/or service
            providers), as well as information about the browser, system, and
            device used;
            <span className="">
              <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR).
            </span>
          </li>
          <li>
            <strong>Cookiebot: </strong>Cookie Consent Management: Procedures
            for obtaining, recording, managing, and revoking consents,
            particularly for the use of cookies and similar technologies for
            storing, accessing, and processing information on users&apos; devices as
            well as their processing; <strong>Service provider</strong>:
            Usercentrics A/S, Havnegade 39, 1058 Kopenhagen, D&auml;nemark;
            <strong>Website:</strong>
            <a href="https://www.cookiebot.com" target="_blank">
              https://www.cookiebot.com
            </a>
            ; <strong>Privacy Policy:</strong>
            <a
              href="https://www.cookiebot.com/en/privacy-policy/"
              target="_blank"
            >
              https://www.cookiebot.com/en/privacy-policy/
            </a>
            ; <strong>Data Processing Agreement:</strong> Provided by the
            service provider; <strong>Further Information:</strong> Stored data
            (on the server of the service provider): The IP number of the user
            in anonymous form (the last three digits are set to 0), date and
            time of the consent, user agent of the user&apos;s browser, the URL from
            which the consent was sent, An anonymous, random and encrypted key
            value. the consent status of the user.
          </li>
        </ul>
        <h2 className="text-2xl font-semibold mb-4" id="m104">Blogs and publication media</h2>
        <p className="mb-4">
          We use blogs or comparable means of online communication and
          publication (hereinafter &quot;publication medium&quot;). Readers&apos; data will
          only be processed for the purposes of the publication medium to the
          extent necessary for its presentation and communication between
          authors and readers or for security reasons. For the rest, we refer to
          the information on the processing of visitors to our publication
          medium within the scope of this privacy policy.
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>Processed data types:</strong> Inventory data (For example,
            the full name, residential address, contact information, customer
            number, etc.); Contact data (e.g. postal and email addresses or
            phone numbers); Content data (e.g. textual or pictorial messages and
            contributions, as well as information pertaining to them, such as
            details of authorship or the time of creation.); Usage data (e.g.
            page views and duration of visit, click paths, intensity and
            frequency of use, types of devices and operating systems used,
            interactions with content and features). Meta, communication and
            process data (e.g. IP addresses, timestamps, identification numbers,
            involved parties).
          </li>
          <li>
            <strong>Data subjects:</strong> Users (e.g. website visitors, users
            of online services).
          </li>
          <li>
            <strong>Purposes of processing:</strong> Feedback (e.g. collecting
            feedback via online form). Provision of our online services and
            usability.
          </li>
          <li>
            <strong>Retention and deletion:</strong> Deletion in accordance with
            the information provided in the section &quot;General Information on Data
            Retention and Deletion&quot;.
          </li>
          <li className="">
            <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
            (f) GDPR).
          </li>
        </ul>
        <h2 className="text-2xl font-semibold mb-4" id="m182">Contact and Inquiry Management</h2>
        <p className="mb-4">
          When contacting us (e.g. via mail, contact form, e-mail, telephone or
          via social media) as well as in the context of existing user and
          business relationships, the information of the inquiring persons is
          processed to the extent necessary to respond to the contact requests
          and any requested measures.
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>Processed data types:</strong> Inventory data (For example,
            the full name, residential address, contact information, customer
            number, etc.); Contact data (e.g. postal and email addresses or
            phone numbers); Content data (e.g. textual or pictorial messages and
            contributions, as well as information pertaining to them, such as
            details of authorship or the time of creation.); Usage data (e.g.
            page views and duration of visit, click paths, intensity and
            frequency of use, types of devices and operating systems used,
            interactions with content and features). Meta, communication and
            process data (e.g. IP addresses, timestamps, identification numbers,
            involved parties).
          </li>
          <li>
            <strong>Data subjects:</strong> Communication partner (Recipients of
            e-mails, letters, etc.).
          </li>
          <li>
            <strong>Purposes of processing:</strong> Communication;
            Organisational and Administrative Procedures; Feedback (e.g.
            collecting feedback via online form). Provision of our online
            services and usability.
          </li>
          <li>
            <strong>Retention and deletion:</strong> Deletion in accordance with
            the information provided in the section &quot;General Information on Data
            Retention and Deletion&quot;.
          </li>
          <li className="">
            <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
            (f) GDPR). Performance of a contract and prior requests (Article 6
            (1) (b) GDPR).
          </li>
        </ul>
        <p className="mb-4">
          <strong>
            Further information on processing methods, procedures and services
            used:
          </strong>
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>Contact form: </strong>Upon contacting us via our contact
            form, email, or other means of communication, we process the
            personal data transmitted to us for the purpose of responding to and
            handling the respective matter. This typically includes details such
            as name, contact information, and possibly additional information
            provided to us that is necessary for appropriate processing. We use
            this data exclusively for the stated purpose of contact and
            communication;
            <span className="">
              <strong>Legal Basis:</strong> Performance of a contract and prior
              requests (Article 6 (1) (b) GDPR), Legitimate Interests (Article 6
              (1) (f) GDPR).
            </span>
          </li>
          <li>
            <strong>HubSpot CRM: </strong>Management of customer contacts,
            tracking of sales activities, automation of marketing campaigns,
            analysis of sales data, creation and management of email campaigns,
            integration with other tools and platforms, management of customer
            support inquiries, AI-supported content generation, personalised
            email creation, predictive sales forecasts, automatic workflow
            descriptions and AI chatbots for customer interaction;
            <strong>Service provider</strong>: HubSpot Irland Limited, Ground
            Floor, Two Dockland Central Guild Street, Dublin 1, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Performance of a contract and prior
              requests (Article 6 (1) (b) GDPR), Legitimate Interests (Article 6
              (1) (f) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://www.hubspot.de/pa/crm" target="_blank">
              https://www.hubspot.de/pa/crm
            </a>
            ; <strong>Privacy Policy:</strong>
            <a href="https://legal.hubspot.com/privacy-policy" target="_blank">
              https://legal.hubspot.com/privacy-policy
            </a>
            ; <strong>Data Processing Agreement:</strong>
            <a href="https://legal.hubspot.com/dpa" target="_blank">
              https://legal.hubspot.com/dpa
            </a>
            . <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Standard Contractual Clauses (
            <a href="https://legal.hubspot.com/dpa" target="_blank">
              https://legal.hubspot.com/dpa
            </a>
            ), Data Privacy Framework (DPF)Standard Contractual Clauses (
            <a href="https://legal.hubspot.com/dpa" target="_blank">
              https://legal.hubspot.com/dpa
            </a>
            ).
          </li>
        </ul>
        <h2 className="text-2xl font-semibold mb-4" id="m391">Communication via Messenger</h2>
        <p className="mb-4">
          We use messenger services for communication purposes and therefore ask
          you to observe the following information regarding the functionality
          of the messenger services, encryption, use of the metadata of the
          communication and your objection options.
        </p>
        <p className="mb-4">
          You can also contact us by alternative means, e.g. telephone or
          e-mail. Please use the contact options provided to you or use the
          contact options provided within our online services.
        </p>
        <p className="mb-4">
          In the case of encryption of content (i.e. the content of your message
          and attachments), we point out that the communication content (i.e.
          the content of the message and attachments) is encrypted end-to-end.
          This means that the content of the messages is not visible, not even
          by the messenger service providers themselves. You should always use a
          current version of the messenger service with activated encryption, so
          that the encryption of the message contents is guaranteed.
        </p>
        <p className="mb-4">
          However, we would like to point out to our communication partners that
          although messenger service providers do not see the content, they can
          find out that and when communication partners communicate with us and
          process technical information on the communication partner&apos;s device
          used and, depending on the settings of their device, also location
          information (so-called metadata).
        </p>
        <p className="mb-4">
          <strong>Information on Legal basis: </strong> If we ask communication
          partners for permission before communicating with them via messenger
          services, the legal basis of our processing of their data is their
          consent. Otherwise, if we do not request consent and you contact us,
          for example, voluntarily, we use messenger services in our dealings
          with our contractual partners and as part of the contract initiation
          process as a contractual measure and in the case of other interested
          parties and communication partners on the basis of our legitimate
          interests in fast and efficient communication and meeting the needs of
          our communication partners for communication via messenger services.
          We would also like to point out that we do not transmit the contact
          data provided to us to the messenger service providers for the first
          time without your consent.
        </p>
        <p className="mb-4">
          <strong>Withdrawal, objection and deletion: </strong> You can withdraw
          your consent or object to communication with us via messenger services
          at any time. In the case of communication via messenger services, we
          delete the messages in accordance with our general data retention
          policy (i.e. as described above after the end of contractual
          relationships, archiving requirements, etc.) and otherwise as soon as
          we can assume that we have answered any information provided by the
          communication partners, if no reference to a previous conversation is
          to be expected and there are no legal obligations to store the
          messages to prevent their deletion.
        </p>
        <p className="mb-4">
          <strong>
            Reservation of reference to other means of communication:
          </strong>
          For your security, we kindly ask for your understanding that we may
          not respond to enquiries via messenger for specific reasons. This
          applies in situations where contract details require heightened
          confidentiality or a response via messenger does not meet formal
          requirements. In such cases, we recommend using more appropriate
          communication channels.
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>Processed data types:</strong> Contact data (e.g. postal and
            email addresses or phone numbers); Content data (e.g. textual or
            pictorial messages and contributions, as well as information
            pertaining to them, such as details of authorship or the time of
            creation.); Usage data (e.g. page views and duration of visit, click
            paths, intensity and frequency of use, types of devices and
            operating systems used, interactions with content and features).
            Meta, communication and process data (e.g. IP addresses, timestamps,
            identification numbers, involved parties).
          </li>
          <li>
            <strong>Data subjects:</strong> Communication partner (Recipients of
            e-mails, letters, etc.).
          </li>
          <li>
            <strong>Purposes of processing:</strong> Communication. Direct
            marketing (e.g. by e-mail or postal).
          </li>
          <li>
            <strong>Retention and deletion:</strong> Deletion in accordance with
            the information provided in the section &quot;General Information on Data
            Retention and Deletion&quot;.
          </li>
          <li className="">
            <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR);
            Performance of a contract and prior requests (Article 6 (1) (b)
            GDPR). Legitimate Interests (Article 6 (1) (f) GDPR).
          </li>
        </ul>
        <p className="mb-4">
          <strong>
            Further information on processing methods, procedures and services
            used:
          </strong>
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>Slack: </strong>Team communication and collaboration,
            real-time messaging, file and document sharing, integration with
            third-party tools, video and voice calls, channels for
            topic-specific discussions, search function for messages and files;
            <strong>Service provider</strong>: Slack Technologies, Inc., 500
            Howard Street, San Francisco, CA 94105, USA;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://slack.com/" target="_blank">
              https://slack.com/
            </a>
            ; <strong>Privacy Policy:</strong>
            <a href="https://slack.com/legal" target="_blank">
              https://slack.com/legal
            </a>
            ; <strong>Data Processing Agreement:</strong>
            <a
              href="https://slack.com/intl/de-de/terms-of-service/data-processing"
              target="_blank"
            >
              https://slack.com/intl/de-de/terms-of-service/data-processing
            </a>
            ; <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Standard Contractual Clauses (
            <a
              href="https://slack.com/intl/de-de/terms-of-service/data-processing"
              target="_blank"
            >
              https://slack.com/intl/de-de/terms-of-service/data-processing
            </a>
            ), Data Privacy Framework (DPF)Standard Contractual Clauses (
            <a
              href="https://slack.com/intl/de-de/terms-of-service/data-processing"
              target="_blank"
            >
              https://slack.com/intl/de-de/terms-of-service/data-processing
            </a>
            ). <strong>Further Information:</strong> Security measures:
            <a
              href="https://slack.com/intl/en-gb/security-practices"
              target="_blank"
            >
              https://slack.com/intl/en-gb/security-practices
            </a>
            .
          </li>
          <li>
            <strong>Telegram: </strong>Sending and receiving messages, voice
            calls, and video calls; creating groups and channels; sharing files
            and media; using bots for automation; end-to-end encryption for
            secret chats; synchronisation across multiple devices;
            <strong>Service provider</strong>: Representative in the European
            Union: European Data Protection Office (EDPO), Avenue Huart Hamoir
            71, 1030 Brussels, Belgium;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://telegram.org/" target="_blank">
              https://telegram.org/
            </a>
            . <strong>Privacy Policy:</strong>
            <a href="https://telegram.org/privacy" target="_blank">
              https://telegram.org/privacy
            </a>
            .
          </li>
          <li>
            <strong>WhatsApp: </strong>Text messages, voice and video calls,
            sending images, videos and documents, group chat functionality,
            end-to-end encryption for enhanced security;
            <strong>Service provider</strong>: WhatsApp Ireland Limited, Merrion
            Road 4, D04 X2K5 Dublin, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://www.whatsapp.com/" target="_blank">
              https://www.whatsapp.com/
            </a>
            ; <strong>Privacy Policy:</strong>
            <a href="https://www.whatsapp.com/legal" target="_blank">
              https://www.whatsapp.com/legal
            </a>
            . <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Data Privacy Framework (DPF).
          </li>
        </ul>
        <h2 className="text-2xl font-semibold mb-4" id="m2555">Artificial Intelligence (AI)</h2>
        <p className="mb-4">
          We use artificial intelligence (AI), which involves the processing of
          personal data. The specific purposes and our interest in using AI are
          mentioned below. According to the term &quot;AI system&quot; as defined in
          Article 3 No. 1 of the AI Regulation, we understand AI to be a
          machine-based system designed for varying degrees of autonomous
          operation, capable of adaptation after deployment, and producing
          outputs such as predictions, content, recommendations, or decisions
          that can influence physical or virtual environments.
        </p>
        <p className="mb-4">
          Our AI systems are used in strict compliance with legal requirements.
          These include both specific regulations for artificial intelligence
          and data protection requirements. In particular, we adhere to the
          principles of lawfulness, transparency, fairness, human oversight,
          purpose limitation, data minimisation, integrity and confidentiality.
          We ensure that the processing of personal data is always based on a
          legal foundation. This may either be the consent of the data subjects
          or a statutory permission.
        </p>
        <p className="mb-4">
          When using external AI systems, we carefully select their providers
          (hereinafter referred to as &quot;AI providers&quot;). In accordance with our
          legal obligations, we ensure that the AI providers comply with
          applicable provisions. We also observe our duties when using or
          operating the acquired AI services. The processing of personal data by
          us and the AI providers is carried out exclusively on the basis of
          consent or legal authorisation. We place particular emphasis on
          transparency, fairness and maintaining human oversight over
          AI-supported decision-making processes.
        </p>
        <p className="mb-4">
          To protect processed data, we implement appropriate and robust
          technical as well as organisational measures. These ensure the
          integrity and confidentiality of processed data and minimise potential
          risks. Through regular reviews of AI providers and their services, we
          ensure ongoing compliance with current legal and ethical standards.
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>Processed data types:</strong> Content data (e.g. textual or
            pictorial messages and contributions, as well as information
            pertaining to them, such as details of authorship or the time of
            creation.). Usage data (e.g. page views and duration of visit, click
            paths, intensity and frequency of use, types of devices and
            operating systems used, interactions with content and features).
          </li>
          <li>
            <strong>Data subjects:</strong> Users (e.g. website visitors, users
            of online services). Third parties.
          </li>
          <li>
            <strong>Purposes of processing:</strong> Artificial Intelligence
            (AI).
          </li>
          <li>
            <strong>Retention and deletion:</strong> Deletion in accordance with
            the information provided in the section &quot;General Information on Data
            Retention and Deletion&quot;.
          </li>
          <li className="">
            <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
            (f) GDPR).
          </li>
        </ul>
        <p className="mb-4">
          <strong>
            Further information on processing methods, procedures and services
            used:
          </strong>
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>OpenAI API: </strong>An AI API that provides developers with
            access to a variety of advanced language and image models, including
            GPT-4 and DALL-E. The OpenAI API enables the integration of complex
            tasks such as text generation, language processing, and image
            analysis into applications; <strong>Service provider</strong>:
            OpenAI Ireland Ltd, 117-126 Sheriff Street Upper, D01 YC43 Dublin 1,
            Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://openai.com/product" target="_blank">
              https://openai.com/product
            </a>
            ; <strong>Privacy Policy:</strong>
            <a
              href="https://openai.com/policies/privacy-policy/"
              target="_blank"
            >
              https://openai.com/policies/privacy-policy/
            </a>
            ; <strong>Data Processing Agreement:</strong>
            <a
              href="https://openai.com/policies/data-processing-addendum"
              target="_blank"
            >
              https://openai.com/policies/data-processing-addendum
            </a>
            ; <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Standard Contractual Clauses (
            <a
              href="https://openai.com/policies/data-processing-addendum"
              target="_blank"
            >
              https://openai.com/policies/data-processing-addendum
            </a>
            ), Data Privacy Framework (DPF)Standard Contractual Clauses (
            <a
              href="https://openai.com/policies/data-processing-addendum"
              target="_blank"
            >
              https://openai.com/policies/data-processing-addendum
            </a>
            ). <strong>Opt-Out:</strong>
            <a
              href="https://privacy.openai.com/policies?modal=select-subject"
              target="_blank"
            >
              https://privacy.openai.com/policies?modal=select-subject
            </a>
            .
          </li>
        </ul>
        <h2 className="text-2xl font-semibold mb-4" id="m735">
          Video Conferences, Online Meetings, Webinars and Screen-Sharing
        </h2>
        <p className="mb-4">
          We use platforms and applications of other providers (hereinafter
          referred to as &quot;Conference Platforms&quot;) for the purpose of conducting
          video and audio conferences, webinars and other types of video and
          audio meetings (hereinafter collectively referred to as &quot;Conference&quot;).
          When using the Conference Platforms and their services, we comply with
          the legal requirements.
        </p>
        <p className="mb-4">
          <strong>Data processed by Conference Platforms:</strong> In the course
          of participation in a Conference, the Data of the participants listed
          below are processed. The scope of the processing depends, on the one
          hand, on which data is requested in the context of a specific
          Conference (e.g., provision of access data or clear names) and which
          optional information is provided by the participants. In addition to
          processing for the purpose of conducting the conference, participants&apos;
          Data may also be processed by the Conference Platforms for security
          purposes or service optimization. The processed Date includes personal
          information (first name, last name), contact information (e-mail
          address, telephone number), access data (access codes or passwords),
          profile pictures, information on professional position/function, the
          IP address of the internet access, information on the participants&apos;
          end devices, their operating system, the browser and its technical and
          linguistic settings, information on the content-related communication
          processes, i.e. entries in chats and audio and video data, as well as
          the use of other available functions (e.g. surveys). The content of
          communications is encrypted to the extent technically provided by the
          conference providers. If participants are registered as users with the
          Conference Platforms, then further data may be processed in accordance
          with the agreement with the respective Conference Provider.
        </p>
        <p className="mb-4">
          <strong>Logging and recording:</strong> If text entries, participation
          results (e.g. from surveys) as well as video or audio recordings are
          recorded, this will be transparently communicated to the participants
          in advance and they will be asked - if necessary - for their consent.
        </p>
        <p className="mb-4">
          <strong>Data protection measures of the participants:</strong> Please
          refer to the data privacy information of the Conference Platforms for
          details on the processing of your data and select the optimum security
          and data privacy settings for you within the framework of the settings
          of the conference platforms. Furthermore, please ensure data and
          privacy protection in the background of your recording for the
          duration of a Conference (e.g., by notifying roommates, locking doors,
          and using the background masking function, if technically possible).
          Links to the conference rooms as well as access data, should not be
          passed on to unauthorized third parties.
        </p>
        <p className="mb-4">
          <strong>Notes on legal bases:</strong> Insofar as, in addition to the
          Conference Platforms, we also process users&apos; data and ask users for
          their consent to use contents from the Conferences or certain
          functions (e.g. consent to a recording of Conferences), the legal
          basis of the processing is this consent. Furthermore, our processing
          may be necessary for the fulfillment of our contractual obligations
          (e.g. in participant lists, in the case of reprocessing of Conference
          results, etc.). Otherwise, user data is processed on the basis of our
          legitimate interests in efficient and secure communication with our
          communication partners.
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>Processed data types:</strong> Inventory data (For example,
            the full name, residential address, contact information, customer
            number, etc.); Contact data (e.g. postal and email addresses or
            phone numbers); Content data (e.g. textual or pictorial messages and
            contributions, as well as information pertaining to them, such as
            details of authorship or the time of creation.); Usage data (e.g.
            page views and duration of visit, click paths, intensity and
            frequency of use, types of devices and operating systems used,
            interactions with content and features); Images and/ or video
            recordings (e.g. photographs or video recordings of a person); Audio
            recordings. Log data (e.g. log files concerning logins or data
            retrieval or access times.).
          </li>
          <li>
            <strong>Data subjects:</strong> Communication partner (Recipients of
            e-mails, letters, etc.); Users (e.g. website visitors, users of
            online services). Persons depicted.
          </li>
          <li>
            <strong>Purposes of processing:</strong> Provision of contractual
            services and fulfillment of contractual obligations; Communication.
            Office and organisational procedures.
          </li>
          <li>
            <strong>Retention and deletion:</strong> Deletion in accordance with
            the information provided in the section &quot;General Information on Data
            Retention and Deletion&quot;.
          </li>
          <li className="">
            <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
            (f) GDPR).
          </li>
        </ul>
        <p className="mb-4">
          <strong>
            Further information on processing methods, procedures and services
            used:
          </strong>
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>Google Hangouts / Meet: </strong>Conference and
            communication software; <strong>Service provider</strong>: Google
            Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://hangouts.google.com/" target="_blank">
              https://hangouts.google.com/
            </a>
            ; <strong>Privacy Policy:</strong>
            <a href="https://policies.google.com/privacy" target="_blank">
              https://policies.google.com/privacy
            </a>
            ; <strong>Data Processing Agreement:</strong>
            <a
              href="https://cloud.google.com/terms/data-processing-addendum"
              target="_blank"
            >
              https://cloud.google.com/terms/data-processing-addendum
            </a>
            . <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Standard Contractual Clauses (
            <a
              href="https://cloud.google.com/terms/eu-model-contract-clause"
              target="_blank"
            >
              https://cloud.google.com/terms/eu-model-contract-clause
            </a>
            ), Data Privacy Framework (DPF)Standard Contractual Clauses (
            <a
              href="https://cloud.google.com/terms/eu-model-contract-clause"
              target="_blank"
            >
              https://cloud.google.com/terms/eu-model-contract-clause
            </a>
            ).
          </li>
          <li>
            <strong>Zoom: </strong>Video conferences, online meetings, webinars,
            screen sharing, optional recording of sessions, chat function,
            integration with calendars and other apps;
            <strong>Service provider</strong>: Zoom Video Communications, Inc.,
            55 Almaden Blvd., Suite 600, San Jose, CA 95113, USA;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://zoom.us" target="_blank">
              https://zoom.us
            </a>
            ; <strong>Privacy Policy:</strong>
            <a href="https://explore.zoom.us/en/privacy/" target="_blank">
              https://explore.zoom.us/en/privacy/
            </a>
            ; <strong>Data Processing Agreement:</strong>
            <a
              href="https://explore.zoom.us/docs/doc/Zoom_GLOBAL_DPA.pdf"
              target="_blank"
            >
              https://explore.zoom.us/docs/doc/Zoom_GLOBAL_DPA.pdf
            </a>
            . <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Standard Contractual Clauses (
            <a
              href="https://explore.zoom.us/docs/doc/Zoom_GLOBAL_DPA.pdf"
              target="_blank"
            >
              https://explore.zoom.us/docs/doc/Zoom_GLOBAL_DPA.pdf
            </a>
            ), Data Privacy Framework (DPF)Standard Contractual Clauses (
            <a
              href="https://explore.zoom.us/docs/doc/Zoom_GLOBAL_DPA.pdf"
              target="_blank"
            >
              https://explore.zoom.us/docs/doc/Zoom_GLOBAL_DPA.pdf
            </a>
            ).
          </li>
        </ul>
        <h2 className="text-2xl font-semibold mb-4" id="m29">Cloud Services</h2>
        <p className="mb-4">
          We use Internet-accessible software services (so-called &quot;cloud
          services&quot;, also referred to as &quot;Software as a Service&quot;) provided on
          the servers of its providers for the storage and management of content
          (e.g. document storage and management, exchange of documents, content
          and information with certain recipients or publication of content and
          information).
        </p>
        <p className="mb-4">
          Within this framework, personal data may be processed and stored on
          the provider&apos;s servers insofar as this data is part of communication
          processes with us or is otherwise processed by us in accordance with
          this privacy policy. This data may include in particular master data
          and contact data of data subjects, data on processes, contracts, other
          proceedings and their contents. Cloud service providers also process
          usage data and metadata that they use for security and service
          optimization purposes.
        </p>
        <p className="mb-4">
          If we use cloud services to provide documents and content to other
          users or publicly accessible websites, forms, etc., providers may
          store cookies on users&apos; devices for web analysis or to remember user
          settings (e.g. in the case of media control).
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>Processed data types:</strong> Inventory data (For example,
            the full name, residential address, contact information, customer
            number, etc.); Contact data (e.g. postal and email addresses or
            phone numbers); Content data (e.g. textual or pictorial messages and
            contributions, as well as information pertaining to them, such as
            details of authorship or the time of creation.). Usage data (e.g.
            page views and duration of visit, click paths, intensity and
            frequency of use, types of devices and operating systems used,
            interactions with content and features).
          </li>
          <li>
            <strong>Data subjects:</strong> Prospective customers; Communication
            partner (Recipients of e-mails, letters, etc.); Business and
            contractual partners. Users (e.g. website visitors, users of online
            services).
          </li>
          <li>
            <strong>Purposes of processing:</strong> Office and organisational
            procedures. Information technology infrastructure (Operation and
            provision of information systems and technical devices, such as
            computers, servers, etc.)).
          </li>
          <li>
            <strong>Retention and deletion:</strong> Deletion in accordance with
            the information provided in the section &quot;General Information on Data
            Retention and Deletion&quot;.
          </li>
          <li className="">
            <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
            (f) GDPR).
          </li>
        </ul>
        <p className="mb-4">
          <strong>
            Further information on processing methods, procedures and services
            used:
          </strong>
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>Google Cloud Storage: </strong>Cloud storage, cloud
            infrastructure services and cloud-based application software;
            <strong>Service provider</strong>: Google Cloud EMEA Limited, 70 Sir
            John Rogerson’s Quay, Dublin 2, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://cloud.google.com/" target="_blank">
              https://cloud.google.com/
            </a>
            ; <strong>Privacy Policy:</strong>
            <a href="https://policies.google.com/privacy" target="_blank">
              https://policies.google.com/privacy
            </a>
            ; <strong>Data Processing Agreement:</strong>
            <a
              href="https://cloud.google.com/terms/data-processing-addendum"
              target="_blank"
            >
              https://cloud.google.com/terms/data-processing-addendum
            </a>
            ; <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Standard Contractual Clauses (
            <a
              href="https://cloud.google.com/terms/eu-model-contract-clause"
              target="_blank"
            >
              https://cloud.google.com/terms/eu-model-contract-clause
            </a>
            ), Data Privacy Framework (DPF)Standard Contractual Clauses (
            <a
              href="https://cloud.google.com/terms/eu-model-contract-clause"
              target="_blank"
            >
              https://cloud.google.com/terms/eu-model-contract-clause
            </a>
            ). <strong>Further Information:</strong>
            <a href="https://cloud.google.com/privacy" target="_blank">
              https://cloud.google.com/privacy
            </a>
            .
          </li>
          <li>
            <strong>Google Workspace: </strong>Cloud storage, cloud
            infrastructure services and cloud-based application software;
            <strong>Service provider</strong>: Google Cloud EMEA Limited, 70 Sir
            John Rogerson’s Quay, Dublin 2, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://workspace.google.com/" target="_blank">
              https://workspace.google.com/
            </a>
            ; <strong>Privacy Policy:</strong>
            <a href="https://policies.google.com/privacy" target="_blank">
              https://policies.google.com/privacy
            </a>
            ; <strong>Data Processing Agreement:</strong>
            <a
              href="https://cloud.google.com/terms/data-processing-addendum"
              target="_blank"
            >
              https://cloud.google.com/terms/data-processing-addendum
            </a>
            ; <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Standard Contractual Clauses (
            <a
              href="https://cloud.google.com/terms/eu-model-contract-clause"
              target="_blank"
            >
              https://cloud.google.com/terms/eu-model-contract-clause
            </a>
            ), Data Privacy Framework (DPF)Standard Contractual Clauses (
            <a
              href="https://cloud.google.com/terms/eu-model-contract-clause"
              target="_blank"
            >
              https://cloud.google.com/terms/eu-model-contract-clause
            </a>
            ). <strong>Further Information:</strong>
            <a href="https://cloud.google.com/privacy" target="_blank">
              https://cloud.google.com/privacy
            </a>
            .
          </li>
        </ul>
        <h2 className="text-2xl font-semibold mb-4" id="m17">Newsletter and Electronic Communications</h2>
        <p className="mb-4">
          We send newsletters, emails, and other electronic notifications
          (hereinafter &quot;newsletters&quot;) exclusively with the consent of the
          recipients or based on a legal basis. If the contents of the
          newsletter are specified during registration for the newsletter, these
          contents are decisive for the users&apos; consent. Normally, providing your
          email address is sufficient to sign up for our newsletter. However, to
          offer you a personalised service, we may ask for your name for
          personal salutation in the newsletter or for additional information if
          necessary for the purpose of the newsletter.
        </p>
        <p className="mb-4">
          Deletion and restriction of processing: We may store unsubscribed
          email addresses for up to three years based on our legitimate
          interests before deleting them to be able to demonstrate previously
          given consent. The processing of these data is limited to the purpose
          of potentially defending against claims. An individual request for
          deletion is possible at any time, provided that at the same time the
          former existence of consent is confirmed. In case of obligations to
          permanently observe objections, we reserve the right to store the
          email address solely for this purpose in a blocklist.
        </p>
        <p className="mb-4">
          The logging of the registration process is based on our legitimate
          interests for the purpose of proving its proper execution. If we
          commission a service provider to send emails, this is done based on
          our legitimate interests in an efficient and secure mailing system.
        </p>
        <strong>Contents:</strong>
        <p className="mb-4">Information about us, our services, promotions and offers.</p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>Processed data types:</strong> Inventory data (For example,
            the full name, residential address, contact information, customer
            number, etc.); Contact data (e.g. postal and email addresses or
            phone numbers); Meta, communication and process data (e.g. IP
            addresses, timestamps, identification numbers, involved parties).
            Usage data (e.g. page views and duration of visit, click paths,
            intensity and frequency of use, types of devices and operating
            systems used, interactions with content and features).
          </li>
          <li>
            <strong>Data subjects:</strong> Communication partner (Recipients of
            e-mails, letters, etc.). Users (e.g. website visitors, users of
            online services).
          </li>
          <li>
            <strong>Purposes of processing:</strong> Direct marketing (e.g. by
            e-mail or postal); Web Analytics (e.g. access statistics,
            recognition of returning visitors). Provision of contractual
            services and fulfillment of contractual obligations.
          </li>
          <li className="">
            <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR).
            Legitimate Interests (Article 6 (1) (f) GDPR).
          </li>
          <li>
            <strong>Opt-Out: </strong>You can cancel the receipt of our
            newsletter at any time, i.e. revoke your consent or object to
            further receipt. You will find a link to cancel the newsletter
            either at the end of each newsletter or you can otherwise use one of
            the contact options listed above, preferably e-mail.
          </li>
        </ul>
        <p className="mb-4">
          <strong>
            Further information on processing methods, procedures and services
            used:
          </strong>
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>Measurement of opening rates and click rates: </strong>The
            newsletters contain a so-called &quot;web beacons&quot;, which is a
            pixel-sized file that is retrieved from our server, or the server of
            the dispatch service provider if one is used, when the newsletter is
            opened. In the course of this retrieval, technical information such
            as details about the browser and your system, as well as your IP
            address and the time of access are collected. This information is
            used to technically improve our newsletter based on technical data
            or target audiences and their reading behavior, which can be
            determined by their access locations (identifiable by IP address) or
            access times. This analysis also includes determining whether and
            when newsletters are opened and which links are clicked. The
            information is assigned to individual newsletter recipients and
            stored in their profiles until deletion. The evaluations serve to
            recognize the reading habits of our users and adjust our content to
            them or send different content according to the interests of our
            users. The measurement of opening and click rates, as well as the
            storage of the measurement results in user profiles and their
            further processing, are based on user consent. Unfortunately, it is
            not possible to revoke success measurement separately; in this case,
            the entire newsletter subscription must be cancelled or objected to.
            In that case, stored profile information will be deleted;
            <span className="">
              <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR).
            </span>
          </li>
          <li>
            <strong>Prerequisite for the use of free services: </strong>Consent
            to the sending of mailings can be made dependent on the use of free
            services (e.g. access to certain content or participation in certain
            campaigns) as a prerequisite. If the users would like to take
            advantage of the free service without registering for the
            newsletter, we offer them to contact us.
          </li>
          <li>
            <strong>Order process reminder emails: </strong>When users cancel an
            order process, we can send them a notice of the cancellation and
            remind them to continue. This function can be useful, for example,
            if the purchase process could not be continued due to a browser
            crash, oversight or forgetting. The dispatch is based on consent,
            which users can object to at any time;
            <span className="">
              <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR).
            </span>
          </li>
          <li>
            <strong>HubSpot Email Marketing: </strong>Sending emails, creating
            personalised campaigns, automating workflows, segmenting target
            audiences, integrating with CRM systems, analysing performance
            through reports and dashboards; <strong>Service provider</strong>:
            HubSpot Irland Limited, Ground Floor, Two Dockland Central Guild
            Street, Dublin 1, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR);
            </span>
            <strong>Website:</strong>
            <a
              href="https://www.hubspot.com/products/marketing/email"
              target="_blank"
            >
              https://www.hubspot.com/products/marketing/email
            </a>
            ; <strong>Privacy Policy:</strong>
            <a href="https://legal.hubspot.com/privacy-policy" target="_blank">
              https://legal.hubspot.com/privacy-policy
            </a>
            ; <strong>Data Processing Agreement:</strong>
            <a href="https://legal.hubspot.com/dpa" target="_blank">
              https://legal.hubspot.com/dpa
            </a>
            ; <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Standard Contractual Clauses (
            <a href="https://legal.hubspot.com/dpa" target="_blank">
              https://legal.hubspot.com/dpa
            </a>
            ), Data Privacy Framework (DPF)Standard Contractual Clauses (
            <a href="https://legal.hubspot.com/dpa" target="_blank">
              https://legal.hubspot.com/dpa
            </a>
            ). <strong>Further Information:</strong>
            <a href="https://legal.hubspot.com/dpa" target="_blank">
              https://legal.hubspot.com/dpa
            </a>
            .
          </li>
          <li>
            <strong>Brevo: </strong>E-mail dispatch and automation services;
            <strong>Service provider</strong>: Sendinblue GmbH, K&ouml;penicker
            Str. 126, 10179 Berlin, Germany;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://www.brevo.com/" target="_blank">
              https://www.brevo.com/
            </a>
            ; <strong>Privacy Policy:</strong>
            <a
              href="https://www.brevo.com/de/legal/privacypolicy/"
              target="_blank"
            >
              https://www.brevo.com/de/legal/privacypolicy/
            </a>
            . <strong>Data Processing Agreement:</strong> Provided by the
            service provider.
          </li>
        </ul>
        <h2 className="text-2xl font-semibold mb-4" id="m263">Web Analysis, Monitoring and Optimization</h2>
        <p className="mb-4">
          Web analytics (also referred to as &quot;reach measurement&quot;) is used to
          evaluate the visitor flows of our online services and may include
          pseudonymous values related to visitor behavior, interests, or
          demographic information such as age or gender. Through reach analysis,
          we can, for example, identify when our online services or their
          functions and content are most frequently used or likely to encourage
          repeat visits. It also enables us to determine which areas need
          optimization.
        </p>
        <p className="mb-4">
          In addition to web analytics, we may also use testing procedures to
          test and optimize different versions of our online services or their
          components.
        </p>
        <p className="mb-4">
          Unless otherwise specified below, profiles (i.e., data combined from a
          usage process) may be created for these purposes, and information can
          be stored in and later retrieved from a browser or device. The data
          collected includes, in particular, visited websites and elements used
          on them, as well as technical information such as the browser used,
          the computer system, and information about usage times. If users have
          given consent to the collection of their location data to us or to the
          providers of the services we use, the processing of location data is
          also possible.
        </p>
        <p className="mb-4">
          Additionally, users&apos; IP addresses are stored. However, we use an IP
          masking process (i.e., pseudonymization by shortening the IP address)
          to protect users. In general, no clear user data (such as email
          addresses or names) is stored as part of web analytics, A/B testing,
          or optimization. Instead, pseudonyms are used. This means that neither
          we nor the providers of the software used know the actual identity of
          the users, only the information stored in their profiles for the
          respective procedures.
        </p>
        <p className="mb-4">
          Legal basis information: If we ask users for their consent to use
          third-party providers, the legal basis for data processing is consent.
          Otherwise, user data is processed based on our legitimate interests
          (i.e., our interest in efficient, economic, and user-friendly
          services). In this context, we would also like to point out the
          information on the use of cookies in this privacy policy.
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>Processed data types:</strong> Usage data (e.g. page views
            and duration of visit, click paths, intensity and frequency of use,
            types of devices and operating systems used, interactions with
            content and features). Meta, communication and process data (e.g. IP
            addresses, timestamps, identification numbers, involved parties).
          </li>
          <li>
            <strong>Data subjects:</strong> Users (e.g. website visitors, users
            of online services).
          </li>
          <li>
            <strong>Purposes of processing:</strong> Remarketing; Affiliate
            Tracking; Web Analytics (e.g. access statistics, recognition of
            returning visitors); Profiles with user-related information
            (Creating user profiles); Provision of our online services and
            usability; Targeting (e.g. profiling based on interests and
            behaviour, use of cookies); Clicktracking; A/B Tests; Heatmaps
            (&quot;Heatmaps&quot; are mouse movements of the users, which are combined to
            an overall picture.); Conversion tracking (Measurement of the
            effectiveness of marketing activities). Marketing.
          </li>
          <li>
            <strong>Retention and deletion:</strong> Deletion in accordance with
            the information provided in the section &quot;General Information on Data
            Retention and Deletion&quot;. Storage of cookies for up to 2 years
            (Unless otherwise stated, cookies and similar storage methods may be
            stored on users&apos; devices for a period of two years.).
          </li>
          <li>
            <strong>Security measures:</strong> IP Masking (Pseudonymization of
            the IP address).
          </li>
          <li className="">
            <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR).
            Legitimate Interests (Article 6 (1) (f) GDPR).
          </li>
        </ul>
        <p className="mb-4">
          <strong>
            Further information on processing methods, procedures and services
            used:
          </strong>
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>Google Analytics: </strong>We use Google Analytics to
            perform measurement and analysis of the use of our online services
            by users based on a pseudonymous user identification number. This
            identification number does not contain any unique data, such as
            names or email addresses. It is used to assign analysis information
            to an end device in order to recognize which content users have
            accessed within one or various usage processes, which search terms
            they have used, have accessed again or have interacted with our
            online services. Likewise, the time of use and its duration are
            stored, as well as the sources of users referring to our online
            services and technical aspects of their end devices and browsers.
            <br />
            In the process, pseudonymous profiles of users are created with
            information from the use of various devices, and cookies may be
            used. Google Analytics does not log or store individual IP
            addresses. Analytics does provide coarse geo-location data by
            deriving the following metadata from IP addresses: City (and the
            derived latitude, and longitude of the city), Continent, Country,
            Region, Subcontinent (and ID-based counterparts). For EU-based
            traffic, IP-address data is used solely for geo-location data
            derivation before being immediately discarded. It is not logged,
            accessible, or used for any additional use cases. When Analytics
            collects measurement data, all IP lookups are performed on EU-based
            servers before forwarding traffic to Analytics servers for
            processing; <strong>Service provider</strong>: Google Ireland
            Limited, Gordon House, Barrow Street, Dublin 4, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR);
            </span>
            <strong>Website:</strong>
            <a
              href="https://marketingplatform.google.com/intl/en/about/analytics/"
              target="_blank"
            >
              https://marketingplatform.google.com/intl/en/about/analytics/
            </a>
            ; <strong>Security measures:</strong> IP Masking (Pseudonymization
            of the IP address); <strong>Privacy Policy:</strong>
            <a href="https://policies.google.com/privacy" target="_blank">
              https://policies.google.com/privacy
            </a>
            ; <strong>Data Processing Agreement:</strong>
            <a
              href="https://business.safety.google/adsprocessorterms/"
              target="_blank"
            >
              https://business.safety.google/adsprocessorterms/
            </a>
            ; <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Standard Contractual Clauses (
            <a
              href="https://business.safety.google/adsprocessorterms"
              target="_blank"
            >
              https://business.safety.google/adsprocessorterms
            </a>
            ), Data Privacy Framework (DPF)Standard Contractual Clauses (
            <a
              href="https://business.safety.google/adsprocessorterms"
              target="_blank"
            >
              https://business.safety.google/adsprocessorterms
            </a>
            ); <strong>Opt-Out:</strong> Opt-Out-Plugin:
            <a
              href="https://tools.google.com/dlpage/gaoptout?hl=en"
              target="_blank"
            >
              https://tools.google.com/dlpage/gaoptout?hl=en
            </a>
            , Settings for the Display of Advertisements:
            <a
              href="https://myadcenter.google.com/personalizationoff"
              target="_blank"
            >
              https://myadcenter.google.com/personalizationoff
            </a>
            . <strong>Further Information:</strong>
            <a
              href="https://business.safety.google/adsservices/"
              target="_blank"
            >
              https://business.safety.google/adsservices/
            </a>
            (Types of processing and data processed).
          </li>
          <li>
            <strong>
              Information on recipients of consent and cookie-less analytics:
            </strong>
            Information on recipients of consent: The consent given by users in
            the context of a consent dialogue (also known as &quot;Cookie
            Opt-In/Consent&quot;, &quot;Cookie Banner&quot;, etc.) serves multiple purposes.
            Firstly, it helps us to fulfil our obligation to obtain consent for
            the storage and reading of information on and from the end-user&apos;s
            device (in accordance with ePrivacy Directives). Secondly, it covers
            the processing of users&apos; personal data in accordance with data
            protection requirements. Additionally, this consent is also
            applicable to Google, as the company is required by the Digital
            Markets Act to obtain consent for personalised services. Therefore,
            we share the status of consents given by users with Google. Our
            consent management software informs Google about whether consents
            have been given or not. The aim is to ensure that user consents—or
            their absence—are taken into account when using Google Analytics and
            integrating features and external services. Thus, user consents and
            their revocation can be dynamically adjusted within our online
            offerings through Google Analytics and other Google services,
            depending on user selection.
            <br />
            Cookieless Analysis: We utilise the advanced implementation of
            consent mode of Google Analytics. This means that if users do not
            give consent for the storage and reading of information on their end
            devices – particularly regarding cookies – no cookies or similar
            information will be stored on the user&apos;s devices. Likewise, no user
            profiles will be created.In this case, Google&apos;s code generates a
            random identification number on the user&apos;s end device and transmits
            it to Google (known as a &quot;ping&quot;). There is no storage of the
            identification in the browser, in apps, or other devices used by the
            user. This identification number is unique for each website visit,
            so that users&apos; behaviour or interests cannot be tracked across
            devices or websites. Only a minimum amount of information about user
            activity is sent. This includes details about consent status and
            information for conversion measurement, i.e., whether a user was
            directed to our online service via a Google
            advertisement.Additionally, where available, the following
            information may be transmitted: a) Function-related information such
            as headers (technical details transmitted by the browser), b)
            Timestamps (date and time of access), c) User-Agent (information
            about the browser and device used, web only), d) Referrer URL (the
            URL of the page from which the user arrived), e)
            Aggregated/pseudonymous information: This includes an indication of
            whether the current or a previous page in the user’s navigation
            history contains information about ad clicks in its URL (e.g.,
            GCLID/DCLID, specific tracking codes from Google), a random number
            generated with each page view, and details about the platform used
            by the website owner for consent management (e.g., developer ID);
            <strong>Service provider</strong>: Google Ireland Limited, Gordon
            House, Barrow Street, Dublin 4, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR);
            </span>
            <strong>Website:</strong>
            <a
              href="https://support.google.com/analytics/answer/9976101?hl=de"
              target="_blank"
            >
              https://support.google.com/analytics/answer/9976101?hl=de
            </a>
            . <strong>Privacy Policy:</strong>
            <a href="https://policies.google.com/privacy" target="_blank">
              https://policies.google.com/privacy
            </a>
            .
          </li>
          <li>
            <strong>Google Signals (Google Analytics function): </strong>Google
            signals are session data from sites and apps that Google associates
            with users who have signed in to their Google accounts, and who have
            turned on Ads Personalization. This association of data with these
            signed-in users is used to enable cross-device reporting,
            cross-device remarketing, and cross-device conversion export to Ads.
            These are the areas where more information is gathered when Google
            Signals is activated (but only for users with Ads Personalization
            enabled): Cross Platform reporting - Connection of data about
            devices and activities from different sessions using your User-ID or
            Google-signals data providing an understanding of user behavior at
            each step of the conversion process, from initial contact to
            conversion and beyond; Remarketing with Google Analytics - Creation
            of remarketing audiences from Google Analytics data, and sharing of
            those audiences with linked advertising accounts; Demographics &
            Interests: Google Analytics collects additional information about
            demographics and interests from users who are signed in to their
            Google accounts and who have turned on Ads Personalization;
            <strong>Service provider</strong>: Google Ireland Limited, Gordon
            House, Barrow Street, Dublin 4, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR);
            </span>
            <strong>Website:</strong>
            <a
              href="https://support.google.com/analytics/answer/7532985?hl=en"
              target="_blank"
            >
              https://support.google.com/analytics/answer/7532985?hl=en
            </a>
            ; <strong>Privacy Policy:</strong>
            <a href="https://policies.google.com/privacy" target="_blank">
              https://policies.google.com/privacy
            </a>
            ; <strong>Data Processing Agreement:</strong>
            <a
              href="https://business.safety.google/adsprocessorterms"
              target="_blank"
            >
              https://business.safety.google/adsprocessorterms
            </a>
            ; <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Standard Contractual Clauses (
            <a
              href="https://business.safety.google/adsprocessorterms"
              target="_blank"
            >
              https://business.safety.google/adsprocessorterms
            </a>
            ), Data Privacy Framework (DPF)Standard Contractual Clauses (
            <a
              href="https://business.safety.google/adsprocessorterms"
              target="_blank"
            >
              https://business.safety.google/adsprocessorterms
            </a>
            ). <strong>Further Information:</strong>
            <a
              href="https://business.safety.google/adsservices/"
              target="_blank"
            >
              https://business.safety.google/adsservices/
            </a>
            (Types of processing and data processed).
          </li>
          <li>
            <strong>Google Analytics Audiences: </strong>We use Google Analytics
            to specifically present ads, placed through Google&apos;s advertising
            services and those of its partners, to users who have already shown
            interest in our online offering or exhibit certain characteristics
            (e.g., interests in specific topics or products determined based on
            the websites they have visited). We transmit this data to Google as
            part of what is known as &quot;Remarketing&quot; or &quot;Google Analytics
            Audiences&quot;. The purpose of using Remarketing Audiences is to ensure
            that our ads align as closely as possible with the potential
            interests of the users; <strong>Service provider</strong>: Google
            Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://marketingplatform.google.com" target="_blank">
              https://marketingplatform.google.com
            </a>
            ;
            <span className="">
              <strong>Legal Basis:</strong>
              <a
                href="https://business.safety.google/adsprocessorterms/"
                target="_blank"
              >
                https://business.safety.google/adsprocessorterms/
              </a>
              ;
            </span>
            <strong>Privacy Policy:</strong>
            <a href="https://policies.google.com/privacy" target="_blank">
              https://policies.google.com/privacy
            </a>
            ; <strong>Data Processing Agreement:</strong>
            <a
              href="https://business.safety.google/adsprocessorterms/"
              target="_blank"
            >
              https://business.safety.google/adsprocessorterms/
            </a>
            ; <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Data Privacy Framework (DPF);
            <strong>Further Information:</strong> Types of processing and data
            processed:
            <a
              href="https://business.safety.google/adsservices/"
              target="_blank"
            >
              https://business.safety.google/adsservices/
            </a>
            . Data Processing Conditions for Google Advertising Products and
            standard contractual clauses for data transfers to third countries:
            <a
              href="https://business.safety.google/adsprocessorterms"
              target="_blank"
            >
              https://business.safety.google/adsprocessorterms
            </a>
            .
          </li>
          <li>
            <strong>Google Tag Manager: </strong>We use Google Tag Manager, a
            software provided by Google, which enables us to manage so-called
            website tags centrally via a user interface. Tags are small code
            elements on our website that serve to record and analyse visitor
            activities. This technology assists us in improving our website and
            the content offered on it. Google Tag Manager itself does not create
            user profiles, store cookies with user profiles, or perform any
            independent analyses. Its function is limited to simplifying and
            making the integration and management of tools and services we use
            on our website more efficient. Nevertheless, when using Google Tag
            Manager, users&apos; IP addresses are transmitted to Google, which is
            technically necessary to implement the services we use. Cookies may
            also be set in this process. However, this data processing only
            occurs if services are integrated via the Tag Manager. For more
            detailed information about these services and their data processing,
            please refer to the further sections of this privacy policy;
            <strong>Service provider</strong>: Google Ireland Limited, Gordon
            House, Barrow Street, Dublin 4, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://marketingplatform.google.com" target="_blank">
              https://marketingplatform.google.com
            </a>
            ; <strong>Privacy Policy:</strong>
            <a href="https://policies.google.com/privacy" target="_blank">
              https://policies.google.com/privacy
            </a>
            ; <strong>Data Processing Agreement:</strong>
            <a
              href="https://business.safety.google/adsprocessorterms"
              target="_blank"
            >
              https://business.safety.google/adsprocessorterms
            </a>
            . <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Standard Contractual Clauses (
            <a
              href="https://business.safety.google/adsprocessorterms"
              target="_blank"
            >
              https://business.safety.google/adsprocessorterms
            </a>
            ), Data Privacy Framework (DPF)Standard Contractual Clauses (
            <a
              href="https://business.safety.google/adsprocessorterms"
              target="_blank"
            >
              https://business.safety.google/adsprocessorterms
            </a>
            ).
          </li>
          <li>
            <strong>Google Tag Manager (server-side use): </strong>Google Tag
            Manager is a solution with which we can manage so-called website
            tags via an interface and thus integrate other services into our
            online services (please refer to further information in this privacy
            policy). With the Tag Manager itself (which implements the tags),
            therefore, neither user profiles nor cookies are stored. The
            integration of the other services is server-based. This means that
            the users&apos; data is not transmitted directly from their end device to
            the respective service. In particular, the IP address of the users
            is not transmitted to the other service or Google. Instead, the data
            is first transmitted to our server, where the user&apos;s data records
            are assigned to our internal user identification number. Subsequent
            transmission takes place only in this pseudonymized form from our
            server to the servers of the respective service providers. The
            identification number does not contain any unique data, such as
            names or e-mail addresses; <strong>Service provider</strong>: Google
            Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR);
            </span>
            <strong>Website:</strong>
            <a
              href="https://marketingplatform.google.com/intl/en/about/analytics/"
              target="_blank"
            >
              https://marketingplatform.google.com/intl/en/about/analytics/
            </a>
            ; <strong>Privacy Policy:</strong>
            <a href="https://policies.google.com/privacy" target="_blank">
              https://policies.google.com/privacy
            </a>
            ; <strong>Data Processing Agreement:</strong>
            <a
              href="https://business.safety.google/adsprocessorterms/"
              target="_blank"
            >
              https://business.safety.google/adsprocessorterms/
            </a>
            ; <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Standard Contractual Clauses (
            <a
              href="https://business.safety.google/adsprocessorterms/"
              target="_blank"
            >
              https://business.safety.google/adsprocessorterms/
            </a>
            ), Data Privacy Framework (DPF)Standard Contractual Clauses (
            <a
              href="https://business.safety.google/adsprocessorterms/"
              target="_blank"
            >
              https://business.safety.google/adsprocessorterms/
            </a>
            ). <strong>Further Information:</strong>
            <a
              href="https://business.safety.google/adsservices/"
              target="_blank"
            >
              https://business.safety.google/adsservices/
            </a>
            (Types of processing and data processed).
          </li>
          <li>
            <strong>Hotjar Observe: </strong>Software for the analysis and
            optimization of online services based on pseudonymously performed
            measurements and analyses of user behavior, which may include in
            particular A/B tests (measurement of the popularity and
            user-friendliness of different content and functions), measurement
            of click paths and interaction with content and functions of the
            online service (as so-called heat maps and recordings);
            <strong>Service provider</strong>: Hotjar Ltd., 3 Lyons Range, 20
            Bisazza Street, Sliema SLM 1640, Malta;
            <span className="">
              <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://www.hotjar.com" target="_blank">
              https://www.hotjar.com
            </a>
            ; <strong>Privacy Policy:</strong>
            <a
              href="https://www.hotjar.com/legal/policies/privacy"
              target="_blank"
            >
              https://www.hotjar.com/legal/policies/privacy
            </a>
            ; <strong>Retention period:</strong> The cookies that Hotjar uses
            have a different &quot;lifetime&quot;; some last up to 365 days, some only
            last during the current visit; cookie policy:
            <a
              href="https://www.hotjar.com/legal/policies/cookie-information"
              target="_blank"
            >
              https://www.hotjar.com/legal/policies/cookie-information
            </a>
            . <strong>Opt-Out:</strong>
            <a
              href="https://www.hotjar.com/legal/compliance/opt-out"
              target="_blank"
            >
              https://www.hotjar.com/legal/compliance/opt-out
            </a>
            .
          </li>
          <li>
            <strong>HubSpot Tracking Code: </strong>The tracking code and
            tracking pixel collect visitor data, including website activities,
            IP addresses, and online identifiers, to monitor website traffic and
            analyze user behavior. This data helps identify visiting companies,
            associate visits with known contacts, and store information about
            browsers and devices. The insights gained contribute to optimizing
            user experience and website performance. The collected data includes
            the company domain (when self-identified through form submission or
            registration), IP address, visit timestamps, visitor ID, page views,
            clicks, and device information. Additionally, interactions such as
            scrolling behavior, time spent on pages, navigation paths, and
            referring URLs are tracked to enable a more precise analysis of user
            behavior and detailed insights into visitor journeys. This data is
            processed based on cookie consent and account settings to improve
            digital services, generate reports on website traffic and
            interactions, and refine strategies for optimizing content and user
            engagement. By analyzing user behavior, businesses can tailor
            content, improve conversion rates, and optimize marketing efforts.
            Furthermore, the data collection helps identify repeat visits,
            segment audiences, and personalize user experiences based on past
            interactions. Additionally, tracking mechanisms allow businesses to
            track leads and assess the effectiveness of marketing campaigns by
            analyzing click-through rates, form submissions, and interactions
            with call-to-action elements. This data helps optimize strategies,
            target audiences more effectively, and maximize engagement with
            digital content; <strong>Service provider</strong>: HubSpot Irland
            Limited, Ground Floor, Two Dockland Central Guild Street, Dublin 1,
            Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR);
            </span>
            <strong>Website:</strong>
            <a
              href="https://knowledge.hubspot.com/account/how-does-hubspot-track-visitors"
              target="_blank"
            >
              https://knowledge.hubspot.com/account/how-does-hubspot-track-visitors
            </a>
            ; <strong>Privacy Policy:</strong>
            <a href="https://legal.hubspot.com/privacy-policy" target="_blank">
              https://legal.hubspot.com/privacy-policy
            </a>
            ; <strong>Data Processing Agreement:</strong>
            <a href="https://legal.hubspot.com/dpa" target="_blank">
              https://legal.hubspot.com/dpa
            </a>
            . <strong>Basis for third-country transfers:</strong> Standard
            Contractual Clauses (
            <a href="https://legal.hubspot.com/dpa" target="_blank">
              https://legal.hubspot.com/dpa
            </a>
            ), Standard Contractual Clauses (
            <a href="https://legal.hubspot.com/dpa" target="_blank">
              https://legal.hubspot.com/dpa
            </a>
            ).
          </li>
          <li>
            <strong>Matomo (without cookies): </strong>Matomo is a data
            protection friendly web analysis software, which is used without
            cookies and in which the recognition of returning users is carried
            out with the help of a so-called &quot;digital fingerprint&quot;, which is
            stored anonymously and changed every 24 hours; in the case of the
            &quot;digital fingerprint&quot;, user movements within our online services are
            recorded with the help of pseudonymised IP addresses in combination
            with user-side browser settings in such a way that conclusions about
            the identity of individual users are not possible. User data
            collected through the use of Matomo is processed only by us and is
            not shared with third parties;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://matomo.org/" target="_blank">
              https://matomo.org/
            </a>
            . <strong>Security measures:</strong> IP Masking (Pseudonymization
            of the IP address).
          </li>
          <li>
            <strong>Microsoft Clarity: </strong>Web analysis, measuring reach
            and analyzing user behavior in relation to the use and interests
            regarding functions and content as well as their duration of use
            based on a pseudonymous user identification number and profile
            creation; <strong>Service provider</strong>: Microsoft Irland
            Operations Limited, One Microsoft Place, South County Business Park,
            Leopardstown, Dublin 18, D18 P521, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://clarity.microsoft.com" target="_blank">
              https://clarity.microsoft.com
            </a>
            ; <strong>Privacy Policy:</strong>
            <a
              href="https://privacy.microsoft.com/en-us/privacystatement"
              target="_blank"
            >
              https://privacy.microsoft.com/en-us/privacystatement
            </a>
            ; <strong>Data Processing Agreement:</strong>
            <a
              href="https://www.microsoft.com/licensing/docs/view/Microsoft-Products-and-Services-Data-Protection-Addendum-DPA"
              target="_blank"
            >
              https://www.microsoft.com/licensing/docs/view/Microsoft-Products-and-Services-Data-Protection-Addendum-DPA
            </a>
            . <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Standard Contractual Clauses (
            <a
              href="https://privacy.microsoft.com/en-us/privacystatement"
              target="_blank"
            >
              https://privacy.microsoft.com/en-us/privacystatement
            </a>
            ), Data Privacy Framework (DPF)Standard Contractual Clauses (
            <a
              href="https://privacy.microsoft.com/en-us/privacystatement"
              target="_blank"
            >
              https://privacy.microsoft.com/en-us/privacystatement
            </a>
            ).
          </li>
          <li>
            <strong>Clarity: </strong>Software for the analysis and optimisation
            of online services on the basis of feedback functions as well as
            pseudonymously conducted measurements and analyses of user
            behaviour, which may include in particular A/B tests (measurement of
            the preference and user-friendliness of different contents and
            functions), measurement of click paths and other interactions with
            contents and functions of the online services;
            <strong>Service provider</strong>: Microsoft Ireland Operations
            Limited, One Microsoft Place, South County Business Park,
            Leopardstown, Dublin 18, D18 P521, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://clarity.microsoft.com/" target="_blank">
              https://clarity.microsoft.com/
            </a>
            ; <strong>Privacy Policy:</strong>
            <a
              href="https://privacy.microsoft.com/en-GB/privacystatement"
              target="_blank"
            >
              https://privacy.microsoft.com/en-GB/privacystatement
            </a>
            , Security information:
            <a
              href="https://www.microsoft.com/en-GB/trust-center"
              target="_blank"
            >
              https://www.microsoft.com/en-GB/trust-center
            </a>
            . <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Data Privacy Framework (DPF).
          </li>
        </ul>
        <h2 className="text-2xl font-semibold mb-4" id="m264">Online Marketing</h2>
        <p className="mb-4">
          We process personal data for the purposes of online marketing, which
          may include in particular the marketing of advertising space or the
          display of advertising and other content (collectively referred to as
            &quot;Content&quot;) based on the potential interests of users and the
          measurement of their effectiveness.
        </p>
        <p className="mb-4">
          For these purposes, so-called user profiles are created and stored in
          a file (so-called &quot;cookie&quot;) or similar procedure is used by which the
          relevant user information for the display of the aforementioned
          content is stored. This information may include, for example, content
          viewed, websites visited, online networks used, communication partners
          and technical information such as the browser used, computer system
          used and information on usage times and used functions. If users have
          consented to the collection of their sideline data, these can also be
          processed.
        </p>
        <p className="mb-4">
          The IP addresses of the users are also stored. However, we use
          provided IP masking procedures (i.e. pseudonymisation by shortening
          the IP address) to ensure the protection of the user&apos;s by using a
          pseudonym. In general, within the framework of the online marketing
          process, no clear user data (such as e-mail addresses or names) is
          secured, but pseudonyms. This means that we, as well as the providers
          of online marketing procedures, do not know the actual identity of the
          users, but only the information stored in their profiles.
        </p>
        <p className="mb-4">
          The information in the profiles is usually stored in the cookies or
          similar memorizing procedures. These cookies can later, generally also
          on other websites that use the same online marketing technology, be
          read and analyzed for purposes of content display, as well as
          supplemented with other data and stored on the server of the online
          marketing technology provider.
        </p>
        <p className="mb-4">
          Exceptionally, clear data can be assigned to the profiles. This is the
          case, for example, if the users are members of a social network whose
          online marketing technology we use and the network links the profiles
          of the users in the aforementioned data. Please note that users may
          enter into additional agreements with the social network providers or
          other service providers, e.g. by consenting as part of a registration
          process.
        </p>
        <p className="mb-4">
          As a matter of principle, we only gain access to summarised
          information about the performance of our advertisements. However,
          within the framework of so-called conversion measurement, we can check
          which of our online marketing processes have led to a so-called
          conversion, i.e. to the conclusion of a contract with us. The
          conversion measurement is used alone for the performance analysis of
          our marketing activities.
        </p>
        <p className="mb-4">
          Unless otherwise stated, we kindly ask you to consider that cookies
          used will be stored for a period of two years.
        </p>
        <p className="mb-4">
          <strong>Notes on revocation and objection:</strong>
        </p>
        <p className="mb-4">
          We refer to the privacy policies of the respective service providers
          and the possibilities for objection (so-called &quot;opt-out&quot;). If no
          explicit opt-out option has been specified, it is possible to
          deactivate cookies in the settings of your browser. However, this may
          restrict the functions of our online offer. We therefore recommend the
          following additional opt-out options, which are offered collectively
          for each area:
        </p>
        <p className="mb-4">
          a) Europe:
          <a href="https://www.youronlinechoices.eu" target="_blank">
            https://www.youronlinechoices.eu.
          </a>
        </p>
        <p className="mb-4">
          b) Canada:
          <a href="https://www.youradchoices.ca/choices" target="_blank">
            https://www.youradchoices.ca/choices.
          </a>
        </p>
        <p className="mb-4">
          c) USA:
          <a href="https://www.aboutads.info/choices" target="_blank">
            https://www.aboutads.info/choices.
          </a>
        </p>
        <p className="mb-4">
          d) Cross-regional:
          <a href="https://optout.aboutads.info" target="_blank">
            https://optout.aboutads.info.
          </a>
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>Processed data types:</strong> Content data (e.g. textual or
            pictorial messages and contributions, as well as information
            pertaining to them, such as details of authorship or the time of
            creation.); Usage data (e.g. page views and duration of visit, click
            paths, intensity and frequency of use, types of devices and
            operating systems used, interactions with content and features);
            Meta, communication and process data (e.g. IP addresses, timestamps,
            identification numbers, involved parties); Event Data (Facebook)
            (&quot;Event Data&quot; is data that can be transmitted from us to Facebook,
            e.g. via Facebook pixels (via apps or other means) and relates to
            persons or their actions; the data includes, for example,
            information about visits to websites, interactions with content,
            functions, installations of apps, purchases of products, etc.; Event
            data is processed for the purpose of creating target groups for
            content and advertising information (Custom Audiences); Event Data
            does not include the actual content (such as written comments),
            login information, and Contact Information (such as names, email
            addresses, and phone numbers). Event Data is deleted by Facebook
            after a maximum of two years, the Custom Audiences created from them
            with the deletion of our Facebook account); Contact Information
            (Facebook) (&quot;Contact Information&quot; is data that (clearly) identifies
            data subjects, such as names, email addresses and phone numbers,
            that can be transmitted to Facebook, e.g. via Facebook pixels or
            uploads for matching purposes to form Custom Audiences. After the
            matching to create target groups, the Contact Information is
            deleted).
          </li>
          <li>
            <strong>Data subjects:</strong> Users (e.g. website visitors, users
            of online services).
          </li>
          <li>
            <strong>Purposes of processing:</strong> Web Analytics (e.g. access
            statistics, recognition of returning visitors); Targeting (e.g.
            profiling based on interests and behaviour, use of cookies);
            Conversion tracking (Measurement of the effectiveness of marketing
            activities); Affiliate Tracking; Marketing; Profiles with
            user-related information (Creating user profiles); Provision of our
            online services and usability; Remarketing. Clicktracking.
          </li>
          <li>
            <strong>Retention and deletion:</strong> Deletion in accordance with
            the information provided in the section &quot;General Information on Data
            Retention and Deletion&quot;. Storage of cookies for up to 2 years
            (Unless otherwise stated, cookies and similar storage methods may be
            stored on users&apos; devices for a period of two years.).
          </li>
          <li>
            <strong>Security measures:</strong> IP Masking (Pseudonymization of
            the IP address).
          </li>
          <li className="">
            <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR).
            Legitimate Interests (Article 6 (1) (f) GDPR).
          </li>
        </ul>
        <p className="mb-4">
          <strong>
            Further information on processing methods, procedures and services
            used:
          </strong>
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>
              Meta Pixel and Custom Audiences (Custom Audiences):
            </strong>
            With the help of the Meta-Pixel (or equivalent functions, to
            transfer Event-Data or Contact Information via interfaces or other
            software in apps), Meta is on the one hand able to determine the
            visitors of our online services as a target group for the
            presentation of ads (so-called &quot;Meta ads&quot;). Accordingly, we use
            Meta-Pixels to display Meta ads placed by us only to Meta users and
            within the services of partners cooperating with Meta (so-called
              &quot;audience network&quot;
            <a href="https://www.facebook.com/audiencenetwork/" target="_blank">
              https://www.facebook.com/audiencenetwork/
            </a>
            ) who have shown an interest in our online services or who have
            certain characteristics (e.g. interests in certain topics or
            products that are determined on the basis of the websites visited)
            that we transmit to Meta (so-called &quot;custom audiences&quot;). With the
            help of Meta-Pixels, we also want to ensure that our Meta ads
            correspond to the potential interest of users and do not appear
            annoying. The Meta-Pixel also enables us to track the effectiveness
            of Meta ads for statistical and market research purposes by showing
            whether users were referred to our website after clicking on a Meta
            ad (known as &quot;conversion tracking&quot;);
            <strong>Service provider</strong>: Meta Platforms Ireland Limited,
            Merrion Road, Dublin 4, D04 X2K5, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://www.facebook.com" target="_blank">
              https://www.facebook.com
            </a>
            ; <strong>Privacy Policy:</strong>
            <a href="https://www.facebook.com/privacy/policy/" target="_blank">
              https://www.facebook.com/privacy/policy/
            </a>
            ; <strong>Data Processing Agreement:</strong>
            <a
              href="https://www.facebook.com/legal/terms/dataprocessing"
              target="_blank"
            >
              https://www.facebook.com/legal/terms/dataprocessing
            </a>
            ; <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Standard Contractual Clauses (
            <a
              href="https://www.facebook.com/legal/EU_data_transfer_addendum"
              target="_blank"
            >
              https://www.facebook.com/legal/EU_data_transfer_addendum
            </a>
            ), Data Privacy Framework (DPF)Standard Contractual Clauses (
            <a
              href="https://www.facebook.com/legal/EU_data_transfer_addendum"
              target="_blank"
            >
              https://www.facebook.com/legal/EU_data_transfer_addendum
            </a>
            ). <strong>Further Information:</strong> User event data, i.e.
            behavioral and interest data, is processed for the purposes of
            targeted advertising and audience building on the basis of the joint
            controllership agreement (&quot;Controller Addendum&quot;,
            <a
              href="https://www.facebook.com/legal/controller_addendum"
              target="_blank"
            >
              https://www.facebook.com/legal/controller_addendum
            </a>
            ). The joint controllership is limited to the collection and
            transfer of the data to Meta Platforms Ireland Limited, a company
            located in the EU. Further processing of the data is the sole
            responsibility of Meta Platforms Ireland Limited, which concerns in
            particular the transfer of the data to the parent company Meta
            Platforms, Inc. in the USA (on the basis of standard contractual
            clauses concluded between Meta Platforms Ireland Limited and Meta
            Platforms, Inc.).
          </li>
          <li>
            <strong>Advanced matching for the Meta-Pixel: </strong>In addition
            to the processing of Event Data in the context of the use of the
            Meta-Pixel (or equivalent functions, e.g. in apps), Contact
            Information (data identifying individual persons, names, email
            addresses and telephone numbers) is also collected by Meta within
            our online offer or transmitted to Meta. The processing of contact
            information serves to form target groups (so-called &quot; Custom
            Audiences&quot;) for the display of content and advertising information
            based on the presumed interests of users. The collection, or
            transmission and matching with data available on Meta is not in
            plain text, but as so-called &quot;hash values&quot;, i.e. mathematical
            representations of the data (this method is used, for example, in
            the storage of passwords). After the matching to create target
            groups, the Contact Information is deleted;
            <span className="">
              <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR);
            </span>
            <strong>Privacy Policy:</strong> Meta Platforms Ireland Limited,
            Merrion Road, Dublin 4, D04 X2K5, Ireland;
            <strong>Data Processing Agreement:</strong>
            <a
              href="https://www.facebook.com/legal/terms/dataprocessing"
              target="_blank"
            >
              https://www.facebook.com/legal/terms/dataprocessing
            </a>
            ; <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Standard Contractual Clauses (
            <a
              href="https://www.facebook.com/legal/EU_data_transfer_addendum"
              target="_blank"
            >
              https://www.facebook.com/legal/EU_data_transfer_addendum
            </a>
            ), Data Privacy Framework (DPF)Standard Contractual Clauses (
            <a
              href="https://www.facebook.com/legal/EU_data_transfer_addendum"
              target="_blank"
            >
              https://www.facebook.com/legal/EU_data_transfer_addendum
            </a>
            ). <strong>Further Information:</strong>
            <a
              href="https://www.facebook.com/legal/terms/data_security_terms"
              target="_blank"
            >
              https://www.facebook.com/legal/terms/data_security_terms
            </a>
            .
          </li>
          <li>
            <strong>Meta - Custom Audiences from File: </strong>Creation of
            target groups for marketing purposes - We submit Contact Information
            (names, email addresses and phone numbers) to Meta in list form for
            the purpose of creating Custom Audiences for content and advertising
            information based on the presumed interests of users. The
            transmission and matching with data available on Meta is not in
            plain text, but as so-called &quot;hash values&quot;, i.e. mathematical
            representations of the data (this method is used, for example, in
            the storage of passwords). After the matching to create target
            groups, the Contact Information is deleted;
            <strong>Service provider</strong>: Meta Platforms Ireland Limited,
            Merrion Road, Dublin 4, D04 X2K5, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://www.facebook.com" target="_blank">
              https://www.facebook.com
            </a>
            ; <strong>Privacy Policy:</strong>
            <a href="https://www.facebook.com/privacy/policy/" target="_blank">
              https://www.facebook.com/privacy/policy/
            </a>
            ; <strong>Data Processing Agreement:</strong>
            <a
              href="https://www.facebook.com/legal/terms/dataprocessing"
              target="_blank"
            >
              https://www.facebook.com/legal/terms/dataprocessing
            </a>
            . <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Standard Contractual Clauses (
            <a
              href="https://www.facebook.com/legal/EU_data_transfer_addendum"
              target="_blank"
            >
              https://www.facebook.com/legal/EU_data_transfer_addendum
            </a>
            ), Data Privacy Framework (DPF)Standard Contractual Clauses (
            <a
              href="https://www.facebook.com/legal/EU_data_transfer_addendum"
              target="_blank"
            >
              https://www.facebook.com/legal/EU_data_transfer_addendum
            </a>
            ).
          </li>
          <li>
            <strong>Facebook Ads: </strong>Placement of ads within the Facebook
            platform and analysis of ad results;
            <strong>Service provider</strong>: Meta Platforms Ireland Limited,
            Merrion Road, Dublin 4, D04 X2K5, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://www.facebook.com" target="_blank">
              https://www.facebook.com
            </a>
            ; <strong>Privacy Policy:</strong>
            <a href="https://www.facebook.com/privacy/policy/" target="_blank">
              https://www.facebook.com/privacy/policy/
            </a>
            ; <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Data Privacy Framework (DPF);
            <strong>Opt-Out:</strong> We refer to the privacy and advertising
            settings in the users&apos; profiles on the Facebook platforms, as well
            as to Facebook&apos;s consent procedures and contact options for
            exercising access and other data subject rights, as described in
            Facebook&apos;s privacy policy. <strong>Further Information:</strong>
            User event data, i.e. behavioral and interest data, is processed for
            the purposes of targeted advertising and audience building on the
            basis of the joint controllership agreement (&quot;Controller Addendum&quot;,
            <a
              href="https://www.facebook.com/legal/controller_addendum"
              target="_blank"
            >
              https://www.facebook.com/legal/controller_addendum
            </a>
            ). The joint controllership is limited to the collection and
            transfer of the data to Meta Platforms Ireland Limited, a company
            located in the EU. Further processing of the data is the sole
            responsibility of Meta Platforms Ireland Limited, which concerns in
            particular the transfer of the data to the parent company Meta
            Platforms, Inc. in the USA (on the basis of standard contractual
            clauses concluded between Meta Platforms Ireland Limited and Meta
            Platforms, Inc.).
          </li>
          <li>
            <strong>Google Ad Manager: </strong>We use the service &quot;Google Ad
            Manager&quot; to place ads in the Google advertising network (e.g. in
            search results, videos, websites, etc.). The Google Ad Manager
            stands out because ads are displayed in real time based on users&apos;
            presumed interests. This allows us to display ads for our online
            offering to users who may have a potential interest in our offering
            or who have previously shown interest, and measure the success of
            the ads; <strong>Service provider</strong>: Google Ireland Limited,
            Gordon House, Barrow Street, Dublin 4, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://marketingplatform.google.com" target="_blank">
              https://marketingplatform.google.com
            </a>
            ; <strong>Privacy Policy:</strong>
            <a href="https://policies.google.com/privacy" target="_blank">
              https://policies.google.com/privacy
            </a>
            ; <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Data Privacy Framework (DPF);
            <strong>Further Information:</strong> Types of processing and data
            processed:
            <a
              href="https://business.safety.google/adsservices/"
              target="_blank"
            >
              https://business.safety.google/adsservices/
            </a>
            ; Google Ads Controller-Controller Data Protection Terms and
            standard contractual clauses for data transfers to third countries:
            <a
              href="https://business.safety.google/adscontrollerterms"
              target="_blank"
            >
              https://business.safety.google/adscontrollerterms
            </a>
            . where Google acts as processor, Data Processing Conditions for
            Google Advertising Products and standard contractual clauses for
            data transfers to third countries:
            <a
              href="https://business.safety.google/adsprocessorterms"
              target="_blank"
            >
              https://business.safety.google/adsprocessorterms
            </a>
            apply.
          </li>
          <li>
            <strong>Google Ads and Conversion Tracking: </strong>Online
            marketing process for purposes of placing content and advertisements
            within the provider&apos;s advertising network (e.g., in search results,
            in videos, on web pages, etc.) so that they are displayed to users
            who have a presumed interest in the ads. Furthermore, we measure the
            conversion of the ads, i.e. whether the users took them as a reason
            to interact with the ads and make use of the advertised offers
            (so-called conversion). However, we only receive anonymous
            information and no personal information about individual users;
            <strong>Service provider</strong>: Google Ireland Limited, Gordon
            House, Barrow Street, Dublin 4, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR),
              Legitimate Interests (Article 6 (1) (f) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://marketingplatform.google.com" target="_blank">
              https://marketingplatform.google.com
            </a>
            ; <strong>Privacy Policy:</strong>
            <a href="https://policies.google.com/privacy" target="_blank">
              https://policies.google.com/privacy
            </a>
            ; <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Data Privacy Framework (DPF);
            <strong>Further Information:</strong> Types of processing and data
            processed:
            <a
              href="https://business.safety.google/adsservices/"
              target="_blank"
            >
              https://business.safety.google/adsservices/
            </a>
            . Google Ads Controller-Controller Data Protection Terms and
            standard contractual clauses for data transfers to third countries:
            <a
              href="https://business.safety.google/adscontrollerterms"
              target="_blank"
            >
              https://business.safety.google/adscontrollerterms
            </a>
            .
          </li>
          <li>
            <strong>Google Ads Remarketing: </strong>Google Remarketing, also
            known as retargeting, is a technology that adds users who use an
            online service to a pseudonymous remarketing list so that users can
            be shown ads on other online services based on their visit to the
            online service
            <br />; <strong>Service provider</strong>: Google Ireland Limited,
            Gordon House, Barrow Street, Dublin 4, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://marketingplatform.google.com" target="_blank">
              https://marketingplatform.google.com
            </a>
            ; <strong>Privacy Policy:</strong>
            <a href="https://policies.google.com/privacy" target="_blank">
              https://policies.google.com/privacy
            </a>
            ; <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Data Privacy Framework (DPF);
            <strong>Further Information:</strong> Types of processing and data
            processed:
            <a
              href="https://business.safety.google/adsservices/"
              target="_blank"
            >
              https://business.safety.google/adsservices/
            </a>
            . Google Ads Controller-Controller Data Protection Terms and
            standard contractual clauses for data transfers to third countries:
            <a
              href="https://business.safety.google/adscontrollerterms"
              target="_blank"
            >
              https://business.safety.google/adscontrollerterms
            </a>
            .
          </li>
          <li>
            <strong>Enhanced Conversions for Google Ads: </strong>When users
            click on our Google ads and subsequently use the advertised service
            (so-called &quot;conversion&quot;), the data entered by the user, such as
            email address, name, residential address or telephone number, may be
            transmitted to Google. The hash values are then matched with
            existing Google accounts of the users to better evaluate and improve
            their interaction with the ads (e.g., clicks or views) and thus
            their performance;
            <span className="">
              <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR).
            </span>
            <strong>Website:</strong>
            <a
              href="https://support.google.com/google-ads/answer/9888656"
              target="_blank"
            >
              https://support.google.com/google-ads/answer/9888656
            </a>
            .
          </li>
          <li>
            <strong>Instagram Ads: </strong>Placement of ads within the
            Instagram platform and analysis of ad results;
            <strong>Service provider</strong>: Meta Platforms Ireland Limited,
            Merrion Road, Dublin 4, D04 X2K5, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://www.instagram.com" target="_blank">
              https://www.instagram.com
            </a>
            ; <strong>Privacy Policy:</strong>
            <a
              href="https://privacycenter.instagram.com/policy/"
              target="_blank"
            >
              https://privacycenter.instagram.com/policy/
            </a>
            ; <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Data Privacy Framework (DPF);
            <strong>Opt-Out:</strong> We refer to the data protection and
            advertising settings in the user&apos;s profile on the Instagram platform
            as well as Instagram&apos;s consent procedure and Instagram&apos;s contact
            options for exercising information and other data subject rights in
            Instagram&apos;s privacy policy. <strong>Further Information:</strong>
            User event data, i.e. behavioral and interest data, is processed for
            the purposes of targeted advertising and audience building on the
            basis of the joint controllership agreement (&quot;Controller Addendum&quot;,
            <a
              href="https://www.facebook.com/legal/controller_addendum"
              target="_blank"
            >
              https://www.facebook.com/legal/controller_addendum
            </a>
            ). The joint controllership is limited to the collection and
            transfer of the data to Meta Platforms Ireland Limited, a company
            located in the EU. Further processing of the data is the sole
            responsibility of Meta Platforms Ireland Limited, which concerns in
            particular the transfer of the data to the parent company Meta
            Platforms, Inc. in the USA (on the basis of standard contractual
            clauses concluded between Meta Platforms Ireland Limited and Meta
            Platforms, Inc.).
          </li>
          <li>
            <strong>LinkedIn Insight Tag: </strong>Code that is loaded when a
            user visits our online offering and tracks the user&apos;s behavior and
            conversions, as well as stores it in a profile (possible use cases:
            measuring campaign performance, optimizing ad delivery, building
            custom and similar target groups); <strong>Service provider</strong>
            : LinkedIn Ireland Unlimited Company, Wilton Place, Dublin 2,
            Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://www.linkedin.com" target="_blank">
              https://www.linkedin.com
            </a>
            ; <strong>Privacy Policy:</strong>
            <a
              href="https://www.linkedin.com/legal/privacy-policy"
              target="_blank"
            >
              https://www.linkedin.com/legal/privacy-policy
            </a>
            , cookie policy:
            <a
              href="https://www.linkedin.com/legal/cookie_policy"
              target="_blank"
            >
              https://www.linkedin.com/legal/cookie_policy
            </a>
            ; <strong>Data Processing Agreement:</strong>
            <a href="https://www.linkedin.com/legal/l/dpa" target="_blank">
              https://www.linkedin.com/legal/l/dpa
            </a>
            ; <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Standard Contractual Clauses (
            <a href="https://legal.linkedin.com/dpa" target="_blank">
              https://legal.linkedin.com/dpa
            </a>
            ), Data Privacy Framework (DPF)Standard Contractual Clauses (
            <a href="https://legal.linkedin.com/dpa" target="_blank">
              https://legal.linkedin.com/dpa
            </a>
            ). <strong>Opt-Out:</strong>
            <a
              href="https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out"
              target="_blank"
            >
              https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out
            </a>
            .
          </li>
          <li>
            <strong>UTM Parameter: </strong>Analysis of sources and user actions
            based on an extension of web addresses referring to us with an
            additional parameter, the &quot;UTM&quot; parameter. For example, a UTM
            parameter &quot;utm_source=platformX &utm_medium=video&quot; can tell us that
            a person clicked the link on platform X within a video. The UTM
            parameters provide information about the source of the link, the
            medium used (e.g. social media, website, newsletter), the type of
            campaign or the content of the campaign (e.g. posting, link, image
            and video). With the help of this information, we can, for example,
            check our visibility on the Internet or the effectiveness of our
            campaigns;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR).
            </span>
          </li>
          <li>
            <strong>LinkedIn Ads: </strong>Placement of ads within the LinkedIn
            platform and analysis of ad results;
            <strong>Service provider</strong>: LinkedIn Irland Unlimited
            Company, Wilton Place, Dublin 2, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR),
              Legitimate Interests (Article 6 (1) (f) GDPR);
            </span>
            <strong>Website:</strong>
            <a
              href="https://business.linkedin.com/de-de/marketing-solutions/ads"
              target="_blank"
            >
              https://business.linkedin.com/de-de/marketing-solutions/ads
            </a>
            ; <strong>Privacy Policy:</strong>
            <a
              href="https://www.linkedin.com/legal/privacy-policy"
              target="_blank"
            >
              https://www.linkedin.com/legal/privacy-policy
            </a>
            ; <strong>Data Processing Agreement:</strong>
            <a href="https://www.linkedin.com/legal/l/dpa" target="_blank">
              https://www.linkedin.com/legal/l/dpa
            </a>
            ; <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Standard Contractual Clauses (
            <a href="https://legal.linkedin.com/dpa" target="_blank">
              https://legal.linkedin.com/dpa
            </a>
            ), Data Privacy Framework (DPF)Standard Contractual Clauses (
            <a href="https://legal.linkedin.com/dpa" target="_blank">
              https://legal.linkedin.com/dpa
            </a>
            ). <strong>Opt-Out:</strong>
            <a
              href="https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out"
              target="_blank"
            >
              https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out
            </a>
            .
          </li>
        </ul>
        <h2 className="text-2xl font-semibold mb-4" id="m136">Profiles in Social Networks (Social Media)</h2>
        <p className="mb-4">
          We maintain online presences within social networks and process user
          data in this context in order to communicate with the users active
          there or to offer information about us.
        </p>
        <p className="mb-4">
          We would like to point out that user data may be processed outside the
          European Union. This may entail risks for users, e.g. by making it
          more difficult to enforce users&apos; rights.
        </p>
        <p className="mb-4">
          In addition, user data is usually processed within social networks for
          market research and advertising purposes. For example, user profiles
          can be created on the basis of user behaviour and the associated
          interests of users. The user profiles can then be used, for example,
          to place advertisements within and outside the networks which are
          presumed to correspond to the interests of the users. For these
          purposes, cookies are usually stored on the user&apos;s computer, in which
          the user&apos;s usage behaviour and interests are stored. Furthermore, data
          can be stored in the user profiles independently of the devices used
          by the users (especially if the users are members of the respective
          networks or will become members later on).
        </p>
        <p className="mb-4">
          For a detailed description of the respective processing operations and
          the opt-out options, please refer to the respective data protection
          declarations and information provided by the providers of the
          respective networks.
        </p>
        <p className="mb-4">
          Also in the case of requests for information and the exercise of
          rights of data subjects, we point out that these can be most
          effectively pursued with the providers. Only the providers have access
          to the data of the users and can directly take appropriate measures
          and provide information. If you still need help, please do not
          hesitate to contact us.
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>Processed data types:</strong> Contact data (e.g. postal and
            email addresses or phone numbers); Content data (e.g. textual or
            pictorial messages and contributions, as well as information
            pertaining to them, such as details of authorship or the time of
            creation.); Usage data (e.g. page views and duration of visit, click
            paths, intensity and frequency of use, types of devices and
            operating systems used, interactions with content and features);
            Meta, communication and process data (e.g. IP addresses, timestamps,
            identification numbers, involved parties). Inventory data (For
            example, the full name, residential address, contact information,
            customer number, etc.).
          </li>
          <li>
            <strong>Data subjects:</strong> Users (e.g. website visitors, users
            of online services). Members.
          </li>
          <li>
            <strong>Purposes of processing:</strong> Communication; Feedback
            (e.g. collecting feedback via online form); Public relations;
            Provision of our online services and usability. Information
            technology infrastructure (Operation and provision of information
            systems and technical devices, such as computers, servers, etc.)).
          </li>
          <li>
            <strong>Retention and deletion:</strong> Deletion in accordance with
            the information provided in the section &quot;General Information on Data
            Retention and Deletion&quot;.
          </li>
          <li className="">
            <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
            (f) GDPR). Consent (Article 6 (1) (a) GDPR).
          </li>
        </ul>
        <p className="mb-4">
          <strong>
            Further information on processing methods, procedures and services
            used:
          </strong>
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>Instagram: </strong>Social network, allows the sharing of
            photos and videos, commenting on and favouriting posts, messaging,
            subscribing to profiles and pages; <strong>Service provider</strong>
            : Meta Platforms Ireland Limited, Merrion Road, Dublin 4, D04 X2K5,
            Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://www.instagram.com" target="_blank">
              https://www.instagram.com
            </a>
            ; <strong>Privacy Policy:</strong>
            <a
              href="https://privacycenter.instagram.com/policy/"
              target="_blank"
            >
              https://privacycenter.instagram.com/policy/
            </a>
            . <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Data Privacy Framework (DPF).
          </li>
          <li>
            <strong>Facebook Pages: </strong>Profiles within the social network
            Facebook - We are jointly responsible (so called &quot;joint controller&quot;)
            with Meta Platforms Ireland Limited for the collection (but not the
            further processing) of data of visitors to our Facebook page. This
            data includes information about the types of content users view or
            interact with, or the actions they take (see &quot;Things that you and
            others do and provide&quot; in the Facebook Data Policy:
            <a href="https://www.facebook.com/privacy/policy/" target="_blank">
              https://www.facebook.com/privacy/policy/
            </a>
            ), and information about the devices used by users (e.g., IP
            addresses, operating system, browser type, language settings, cookie
            information; see &quot;Device Information&quot; in the Facebook Data Policy:
            <a href="https://www.facebook.com/privacy/policy/" target="_blank">
              https://www.facebook.com/privacy/policy/
            </a>
            ). As explained in the Facebook Data Policy under &quot;How we use this
            information?&quot; Facebook also collects and uses information to provide
            analytics services, known as &quot;page insights,&quot; to site operators to
            help them understand how people interact with their pages and with
            content associated with them. We have concluded a special agreement
            with Facebook (&quot;Information about Page-Insights&quot;,
            <a
              href="https://www.facebook.com/legal/terms/page_controller_addendum"
              target="_blank"
            >
              https://www.facebook.com/legal/terms/page_controller_addendum
            </a>
            ), which regulates in particular the security measures that Facebook
            must observe and in which Facebook has agreed to fulfill the rights
            of the persons concerned (i.e. users can send information access or
            deletion requests directly to Facebook). The rights of users (in
            particular to access to information, erasure, objection and
            complaint to the competent supervisory authority) are not restricted
            by the agreements with Facebook. Further information can be found in
            the &quot;Information about Page Insights&quot; (
            <a
              href="https://www.facebook.com/legal/terms/information_about_page_insights_data"
              target="_blank"
            >
              https://www.facebook.com/legal/terms/information_about_page_insights_data
            </a>
            ). The joint controllership is limited to the collection and
            transfer of the data to Meta Platforms Ireland Limited, a company
            located in the EU. Further processing of the data is the sole
            responsibility of Meta Platforms Ireland Limited;
            <strong>Service provider</strong>: Meta Platforms Ireland Limited,
            Merrion Road, Dublin 4, D04 X2K5, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://www.facebook.com" target="_blank">
              https://www.facebook.com
            </a>
            ; <strong>Privacy Policy:</strong>
            <a href="https://www.facebook.com/privacy/policy/" target="_blank">
              https://www.facebook.com/privacy/policy/
            </a>
            . <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Standard Contractual Clauses (
            <a
              href="https://www.facebook.com/legal/EU_data_transfer_addendum"
              target="_blank"
            >
              https://www.facebook.com/legal/EU_data_transfer_addendum
            </a>
            ), Data Privacy Framework (DPF)Standard Contractual Clauses (
            <a
              href="https://www.facebook.com/legal/EU_data_transfer_addendum"
              target="_blank"
            >
              https://www.facebook.com/legal/EU_data_transfer_addendum
            </a>
            ).
          </li>
          <li>
            <strong>Facebook-Groups: </strong>We use the &quot;Groups&quot; function of
            the Facebook platform to create interest groups within which
            Facebook users can contact each other or us and exchange
            information. In doing so, we process personal data of the users of
            our groups as far as this is necessary for the purpose of the group
            use as well as its moderation. These data include information on
            first and last names, as well as published or privately shared
            content, as well as values on the status of group membership or
            group-related activities, such as entry or exit, as well as the time
            information on the aforementioned data. Our guidelines within the
            groups may contain further specifications and information on the use
            of the respective group. Furthermore, we would like to point out the
            processing of data of the users by Facebook itself. This data
            includes information about the types of content users view or
            interact with, or the actions they take (see under &quot;Things You and
            Others Do and Provide&quot; in the Facebook Data Policy:
            <a href="https://www.facebook.com/privacy/policy/" target="_blank">
              https://www.facebook.com/privacy/policy/
            </a>
            ), as well as information about the devices users use (e.g., IP
            addresses, operating system, browser type, language settings, cookie
            data; see under &quot;Device Information&quot; in the Facebook Data Policy:
            <a href="https://www.facebook.com/privacy/policy/" target="_blank">
              https://www.facebook.com/privacy/policy/
            </a>
            ). As explained in the Facebook Data Policy under &quot;How do we use
            this information?&quot;, Facebook also collects and uses information to
            provide analytics services, called &quot;Insights,&quot; to group operators to
            provide them with insights about how people interact with their
            groups and with content associated with them;
            <strong>Service provider</strong>: Meta Platforms Ireland Limited,
            Merrion Road, Dublin 4, D04 X2K5, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://www.facebook.com" target="_blank">
              https://www.facebook.com
            </a>
            ; <strong>Privacy Policy:</strong>
            <a href="https://www.facebook.com/privacy/policy/" target="_blank">
              https://www.facebook.com/privacy/policy/
            </a>
            . <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Data Privacy Framework (DPF).
          </li>
          <li>
            <strong>Facebook events: </strong>Event profiles within the social
            network Facebook - We use the &quot;Events&quot; function of the Facebook
            platform to refer to events and dates as well as to get in touch
            with users (participants and interested parties) and to exchange
            information. In doing so, we process personal data of the users of
            our event pages, as far as this is necessary for the purpose of the
            event page as well as its moderation. These data include information
            on first and last names, as well as published or privately
            communicated content, as well as values on the status of
            participation and the time information on the aforementioned data.
            Furthermore, we refer to the processing of data of users by Facebook
            itself. This data includes information about the types of content
            users view or interact with, or the actions they take (see under
              &quot;Things You and Others Do and Provide&quot; in the Facebook Data Policy:
            <a href="https://www.facebook.com/privacy/policy/" target="_blank">
              https://www.facebook.com/privacy/policy/
            </a>
            ), as well as information about the devices users use (e.g., IP
            addresses, operating system, browser type, language settings, cookie
            data; see under &quot;Device Information&quot; in the Facebook Data Policy:
            <a href="https://www.facebook.com/privacy/policy/" target="_blank">
              https://www.facebook.com/privacy/policy/
            </a>
            ). As explained in the Facebook Data Policy under &quot;How do we use
            this information?&quot;, Facebook also collects and uses information to
            provide analytics services, known as &quot;insights,&quot; to event providers
            to provide them with insights about how people interact with their
            event pages and with content associated with them;
            <strong>Service provider</strong>: Meta Platforms Ireland Limited,
            Merrion Road, Dublin 4, D04 X2K5, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://www.facebook.com" target="_blank">
              https://www.facebook.com
            </a>
            ; <strong>Privacy Policy:</strong>
            <a href="https://www.facebook.com/privacy/policy/" target="_blank">
              https://www.facebook.com/privacy/policy/
            </a>
            . <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Data Privacy Framework (DPF).
          </li>
          <li>
            <strong>LinkedIn: </strong>Social network - We are jointly
            responsible with LinkedIn Ireland Unlimited Company for the
            collection (but not the further processing) of visitor data, which
            is used to create &quot;Page Insights&quot; (statistics) for our LinkedIn
            profiles. This data includes information about the types of content
            users view or interact with, as well as the actions they take. It
            also includes details about the devices used, such as IP addresses,
            operating systems, browser types, language settings, and cookie
            data, as well as profile details of users, such as job function,
            country, industry, seniority, company size, and employment status.
            Privacy information regarding the processing of user data by
            LinkedIn can be found in LinkedIn&apos;s privacy policy:
            <a
              href="https://www.linkedin.com/legal/privacy-policy"
              target="_blank"
            >
              https://www.linkedin.com/legal/privacy-policy.
            </a>
            <br />
            We have entered into a special agreement with LinkedIn Ireland
            (&quot;Page Insights Joint Controller Addendum,&quot;
            <a
              href="https://legal.linkedin.com/pages-joint-controller-addendum"
              target="_blank"
            >
              https://legal.linkedin.com/pages-joint-controller-addendum
            </a>
            ), which specifically regulates the security measures LinkedIn must
            comply with and in which LinkedIn has agreed to fulfill the rights
            of data subjects (i.e., users can, for example, direct requests for
            information or deletion directly to LinkedIn). The rights of users
            (particularly the right to information, deletion, objection, and to
            lodge a complaint with the competent supervisory authority) are not
            restricted by our agreements with LinkedIn. The joint responsibility
            is limited to the collection of data and its transmission to
            LinkedIn Ireland Unlimited Company, a company based in the EU.
            Further processing of the data is the sole responsibility of
            LinkedIn Ireland Unlimited Company, particularly concerning the
            transfer of data to the parent company LinkedIn Corporation in the
            USA; <strong>Service provider</strong>: LinkedIn Ireland Unlimited
            Company, Wilton Place, Dublin 2, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://www.linkedin.com" target="_blank">
              https://www.linkedin.com
            </a>
            ; <strong>Privacy Policy:</strong>
            <a
              href="https://www.linkedin.com/legal/privacy-policy"
              target="_blank"
            >
              https://www.linkedin.com/legal/privacy-policy
            </a>
            ; <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Standard Contractual Clauses (
            <a href="https://legal.linkedin.com/dpa" target="_blank">
              https://legal.linkedin.com/dpa
            </a>
            ), Data Privacy Framework (DPF)Standard Contractual Clauses (
            <a href="https://legal.linkedin.com/dpa" target="_blank">
              https://legal.linkedin.com/dpa
            </a>
            ). <strong>Opt-Out:</strong>
            <a
              href="https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out"
              target="_blank"
            >
              https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out
            </a>
            .
          </li>
          <li>
            <strong>Telegram Groups: </strong>We use the Telegram platform to
            create interest groups within which Telegram users can contact each
            other or us and share information; <strong>Service provider</strong>
            : Representative in the European Union: European Data Protection
            Office (EDPO), Avenue Huart Hamoir 71, 1030 Brussels, Belgium;
            <strong>Website:</strong>
            <a href="https://telegram.org/" target="_blank">
              https://telegram.org/
            </a>
            ; <strong>Privacy Policy:</strong>
            <a href="https://telegram.org/privacy" target="_blank">
              https://telegram.org/privacy
            </a>
            . <strong>Further Information:</strong> We process the personal data
            of the group members only insofar as we can manage the group
            members, i.e. add, delete, restrict the use of the group and
            moderate the content. Beyond that, i.e. in particular for the
            provision of technical functions, the evaluation and provision of
            anonymous dispatch statistics for the group operators and the
            administration of the users, Telegram is the controller.
          </li>
          <li>
            <strong>Telegram Channels: </strong>We use the Telegram platform to
            send messages to subscribers of our Telegram channel;
            <strong>Service provider</strong>: Representative in the European
            Union: European Data Protection Office (EDPO), Avenue Huart Hamoir
            71, 1030 Brussels, Belgium; <strong>Website:</strong>
            <a href="https://telegram.org/" target="_blank">
              https://telegram.org/
            </a>
            ; <strong>Privacy Policy:</strong>
            <a href="https://telegram.org/privacy/de" target="_blank">
              https://telegram.org/privacy/de
            </a>
            . <strong>Further Information:</strong> We process the subscribers&apos;
            personal data only to the extent that we can view and delete the
            subscribers as recipients of the channel. Beyond that, i.e. in
            particular for the sending of the messages, the evaluation and
            provision of anonymous sending statistics for the channel operators
            and the administration of the subscribers, Telegram is responsible
            under data protection law.
          </li>
          <li>
            <strong>Threads: </strong>Social network;
            <strong>Service provider</strong>: Meta Platforms Ireland Limited,
            Merrion Road, Dublin 4, D04 X2K5, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://www.threads.net/" target="_blank">
              https://www.threads.net/
            </a>
            . <strong>Privacy Policy:</strong>
            <a
              href="https://help.instagram.com/515230437301944?locale=en_GB"
              target="_blank"
            >
              https://help.instagram.com/515230437301944?locale=en_GB
            </a>
            .
          </li>
          <li>
            <strong>TikTok: </strong>Social network, allows the sharing of
            photos and videos, commenting on and favouriting posts, messaging,
            subscribing to accounts; <strong>Service provider</strong>: TikTok
            Technology Limited, 10 Earlsfort Terrace, Dublin, D02 T380, Ireland
            and TikTok Information Technologies UK Limited, Kaleidoscope, 4
            Lindsey Street, London, United Kingdom, EC1A 9HP;
            <span className="">
              <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://www.tiktok.com" target="_blank">
              https://www.tiktok.com
            </a>
            ; <strong>Privacy Policy:</strong>
            <a href="https://www.tiktok.com/de/privacy-policy" target="_blank">
              https://www.tiktok.com/de/privacy-policy
            </a>
            . <strong>Basis for third-country transfers:</strong> Standard
            Contractual Clauses (
            <a
              href="https://ads.tiktok.com/i18n/official/policy/jurisdiction-specific-terms"
              target="_blank"
            >
              https://ads.tiktok.com/i18n/official/policy/jurisdiction-specific-terms
            </a>
            ), Standard Contractual Clauses (
            <a
              href="https://ads.tiktok.com/i18n/official/policy/jurisdiction-specific-terms"
              target="_blank"
            >
              https://ads.tiktok.com/i18n/official/policy/jurisdiction-specific-terms
            </a>
            ).
          </li>
          <li>
            <strong>X: </strong>Social network;
            <strong>Service provider</strong>: Twitter International Company,
            One Cumberland Place, Fenian Street, Dublin 2 D02 AX07, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://x.com" target="_blank">
              https://x.com
            </a>
            . <strong>Privacy Policy:</strong>
            <a href="https://x.com/privacy" target="_blank">
              https://x.com/privacy
            </a>
            .
          </li>
          <li>
            <strong>YouTube: </strong>Social network and video platform;
            <strong>Service provider</strong>: Google Ireland Limited, Gordon
            House, Barrow Street, Dublin 4, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR);
            </span>
            <strong>Privacy Policy:</strong>
            <a href="https://policies.google.com/privacy" target="_blank">
              https://policies.google.com/privacy
            </a>
            ; <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Data Privacy Framework (DPF).
            <strong>Opt-Out:</strong>
            <a
              href="https://myadcenter.google.com/personalizationoff"
              target="_blank"
            >
              https://myadcenter.google.com/personalizationoff
            </a>
            .
          </li>
          <li>
            <strong>Xing: </strong>Social network;
            <strong>Service provider</strong>: New Work SE, Am Strandkai 1,
            20457 Hamburg, Germany;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://www.xing.com" target="_blank">
              https://www.xing.com
            </a>
            . <strong>Privacy Policy:</strong>
            <a href="https://privacy.xing.com/en" target="_blank">
              https://privacy.xing.com/en
            </a>
            .
          </li>
        </ul>
        <h2 className="text-2xl font-semibold mb-4" id="m328">Plugins and embedded functions and content</h2>
        <p className="mb-4">
          Within our online services, we integrate functional and content
          elements that are obtained from the servers of their respective
          providers (hereinafter referred to as &quot;third-party providers&quot;). These
          may, for example, be graphics, videos or city maps (hereinafter
          uniformly referred to as &quot;Content&quot;).
        </p>
        <p className="mb-4">
          The integration always presupposes that the third-party providers of
          this content process the IP address of the user, since they could not
          send the content to their browser without the IP address. The IP
          address is therefore required for the presentation of these contents
          or functions. We strive to use only those contents, whose respective
          offerers use the IP address only for the distribution of the contents.
          Third parties may also use so-called pixel tags (invisible graphics,
          also known as &quot;web beacons&quot;) for statistical or marketing purposes.
          The &quot;pixel tags&quot; can be used to evaluate information such as visitor
          traffic on the pages of this website. The pseudonymous information may
          also be stored in cookies on the user&apos;s device and may include
          technical information about the browser and operating system,
          referring websites, visit times and other information about the use of
          our website, as well as may be linked to such information from other
          sources.
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>Processed data types:</strong> Usage data (e.g. page views
            and duration of visit, click paths, intensity and frequency of use,
            types of devices and operating systems used, interactions with
            content and features); Meta, communication and process data (e.g. IP
            addresses, timestamps, identification numbers, involved parties);
            Event Data (Facebook) (&quot;Event Data&quot; is data that can be transmitted
            from us to Facebook, e.g. via Facebook pixels (via apps or other
            means) and relates to persons or their actions; the data includes,
            for example, information about visits to websites, interactions with
            content, functions, installations of apps, purchases of products,
            etc.; Event data is processed for the purpose of creating target
            groups for content and advertising information (Custom Audiences);
            Event Data does not include the actual content (such as written
            comments), login information, and Contact Information (such as
            names, email addresses, and phone numbers). Event Data is deleted by
            Facebook after a maximum of two years, the Custom Audiences created
            from them with the deletion of our Facebook account). Contact data
            (e.g. postal and email addresses or phone numbers).
          </li>
          <li>
            <strong>Data subjects:</strong> Users (e.g. website visitors, users
            of online services).
          </li>
          <li>
            <strong>Purposes of processing:</strong> Provision of our online
            services and usability; Marketing; Profiles with user-related
            information (Creating user profiles); Communication; Direct
            marketing (e.g. by e-mail or postal); Web Analytics (e.g. access
            statistics, recognition of returning visitors); Conversion tracking
            (Measurement of the effectiveness of marketing activities); A/B
            Tests. Affiliate Tracking.
          </li>
          <li>
            <strong>Retention and deletion:</strong> Deletion in accordance with
            the information provided in the section&quot;General Information on Data
            Retention and Deletion&quot;. Storage of cookies for up to 2 years
            (Unless otherwise stated, cookies and similar storage methods may be
            stored on users&apos; devices for a period of two years.).
          </li>
          <li className="">
            <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR).
            Legitimate Interests (Article 6 (1) (f) GDPR).
          </li>
        </ul>
        <p className="mb-4">
          <strong>
            Further information on processing methods, procedures and services
            used:
          </strong>
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>
              Integration of third-party software, scripts or frameworks:
            </strong>
            We incorporate into our online services software which we retrieve
            from servers of other providers (e.g. function libraries which we
            use for the purpose of displaying or user-friendliness of our online
            services). The respective providers collect the user&apos;s IP address
            and can process it for the purposes of transferring the software to
            the user&apos;s browser as well as for security purposes and for the
            evaluation and optimisation of their services;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR).
            </span>
          </li>
          <li>
            <strong>Facebook plugins and contents: </strong>Facebook Social
            Plugins and contents - This can include content such as images,
            videos or text and buttons with which users can share content from
            this online service within Facebook. The list and appearance of the
            Facebook Social Plugins can be viewed here:
            <a
              href="https://developers.facebook.com/docs/plugins/"
              target="_blank"
            >
              https://developers.facebook.com/docs/plugins/
            </a>
            - We are jointly responsible (so-called &quot;joint-controllership&quot;) with
            Meta Platforms Ireland Limited for the collection or transmission
            (but not further processing) of &quot;Event Data&quot; that Facebook collects
            or receives as part of a transmission using the Facebook Social
            Plugins that run on our website for the following purposes: a)
            displaying content advertising information that matches users&apos;
            presumed interests; b) delivering commercial and transactional
            messages (e.g. b) delivering commercial and transactional messages
            (e.g., addressing users via Facebook Messenger); c) improving ad
            delivery and personalizing features and content (e.g., improving
            recognition of which content or advertising information is believed
            to be of interest to users). We have entered into a special
            agreement with Facebook (&quot;Controller Addendum&quot;,
            <a
              href="https://www.facebook.com/legal/controller_addendum"
              target="_blank"
            >
              https://www.facebook.com/legal/controller_addendum
            </a>
            ), which specifically addresses the security measures that Facebook
            must take (
            <a
              href="https://www.facebook.com/legal/terms/data_security_terms"
              target="_blank"
            >
              https://www.facebook.com/legal/terms/data_security_terms
            </a>
            ) and in which Facebook has agreed to comply with the rights of data
            subjects (i.e., users can, for example, submit information access or
            deletion requests directly to Facebook). Note: If Facebook provides
            us with measurements, analyses and reports (which are aggregated,
            i.e. do not contain information on individual users and are
            anonymous to us), then this processing is not carried out within the
            scope of joint responsibility, but on the basis of a DPA (&quot;Data
            Processing Terms&quot;,
            <a
              href="https://www.facebook.com/legal/terms/dataprocessing/update"
              target="_blank"
            >
              https://www.facebook.com/legal/terms/dataprocessing/update
            </a>
            ), the &quot;Data Security Conditions&quot; (
            <a
              href="https://www.facebook.com/legal/terms/data_security_terms"
              target="_blank"
            >
              https://www.facebook.com/legal/terms/data_security_terms
            </a>
            ) and, with regard to processing in the USA, on the basis of
            Standard Contractual Clauses (&quot;Facebook EU Data Transfer Addendum,
            <a
              href="https://www.facebook.com/legal/EU_data_transfer_addendum"
              target="_blank"
            >
              https://www.facebook.com/legal/EU_data_transfer_addendum
            </a>
            ). The rights of users (in particular to access to information,
            erasure, objection and complaint to the competent supervisory
            authority) are not restricted by the agreements with Facebook;
            <strong>Service provider</strong>: Meta Platforms Ireland Limited,
            Merrion Road, Dublin 4, D04 X2K5, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Consent (Article 6 (1) (a) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://www.facebook.com" target="_blank">
              https://www.facebook.com
            </a>
            ; <strong>Privacy Policy:</strong>
            <a href="https://www.facebook.com/privacy/policy/" target="_blank">
              https://www.facebook.com/privacy/policy/
            </a>
            . <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Data Privacy Framework (DPF).
          </li>
          <li>
            <strong>LinkedIn plugins and contents: </strong>LinkedIn plugins and
            contents - This can include content such as images, videos or text
            and buttons with which users can share content from this online
            service within LinkedIn; <strong>Service provider</strong>: LinkedIn
            Ireland Unlimited Company, Wilton Place, Dublin 2, Ireland;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://www.linkedin.com" target="_blank">
              https://www.linkedin.com
            </a>
            ; <strong>Privacy Policy:</strong>
            <a
              href="https://www.linkedin.com/legal/privacy-policy"
              target="_blank"
            >
              https://www.linkedin.com/legal/privacy-policy
            </a>
            ; <strong>Data Processing Agreement:</strong>
            <a href="https://legal.linkedin.com/dpa" target="_blank">
              https://legal.linkedin.com/dpa
            </a>
            ; <strong>Basis for third-country transfers:</strong> Data Privacy
            Framework (DPF), Standard Contractual Clauses (
            <a href="https://legal.linkedin.com/dpa" target="_blank">
              https://legal.linkedin.com/dpa
            </a>
            ), Data Privacy Framework (DPF)Standard Contractual Clauses (
            <a href="https://legal.linkedin.com/dpa" target="_blank">
              https://legal.linkedin.com/dpa
            </a>
            ). <strong>Opt-Out:</strong>
            <a
              href="https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out"
              target="_blank"
            >
              https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out
            </a>
            .
          </li>
          <li>
            <strong>Perspective: </strong>Creation of so-called &quot;marketing
            funnels&quot;, i.e. websites, online forms and procedures for contacting
            and closing deals with potential interested parties for offered
            products or services as well as their management, supported by
            export as well as analysis functions;
            <strong>Service provider</strong>: Perspective Software GmbH,
            M&uuml;ggelstra&szlig;e 22, 10247 Berlin, Germany;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR);
            </span>
            <strong>Website:</strong>
            <a href="https://www.perspective.co/" target="_blank">
              https://www.perspective.co/
            </a>
            ; <strong>Privacy Policy:</strong>
            <a href="https://www.perspective.co/privacy-policy" target="_blank">
              https://www.perspective.co/privacy-policy
            </a>
            . <strong>Data Processing Agreement:</strong> Provided by the
            service provider.
          </li>
        </ul>
        <h2 className="text-2xl font-semibold mb-4" id="m1360">
          Processing of data in the context of employment relationships
        </h2>
        <p className="mb-4">
          In the context of employment relationships, the processing of personal
          data aims to effectively manage the establishment, execution, and
          termination of such relationships. This data processing supports
          various operational and administrative functions necessary for
          managing employee relations.
        </p>
        <p className="mb-4">
          The data processing covers various aspects ranging from contract
          initiation to termination. Included are the organization and
          management of daily working hours, management of access rights and
          permissions, as well as handling personnel development measures and
          staff appraisals. The processing also serves payroll accounting and
          management of wage and salary payments, which represent critical
          aspects of contract execution.
        </p>
        <p className="mb-4">
          Additionally, the data processing considers legitimate interests of
          the responsible employer, such as ensuring workplace safety or
          capturing performance data for evaluating and optimizing operational
          processes. Moreover, the data processing includes disclosing employee
          data in external communication and publication processes where
          necessary for operational or legal purposes.
        </p>
        <p className="mb-4">
          The processing of this data always takes place with due regard for the
          applicable legal frameworks, aiming always to create and maintain a
          fair and efficient working environment. This also includes considering
          the privacy of affected employees, anonymizing or deleting data after
          fulfilling the processing purpose or according to legal retention
          periods.
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>Processed data types:</strong> Employee Data (Information
            about employees and other individuals in an employment
            relationship); Payment Data (e.g. bank details, invoices, payment
            history); Contract data (e.g. contract object, duration, customer
            category); Inventory data (For example, the full name, residential
            address, contact information, customer number, etc.); Contact data
            (e.g. postal and email addresses or phone numbers); Content data
            (e.g. textual or pictorial messages and contributions, as well as
            information pertaining to them, such as details of authorship or the
            time of creation.); Social data (Data subject to a special social
            confidentiality obligation and processed, for example, by social
            insurance institutions, social welfare institutions or pension
            authorities.); Log data (e.g. log files concerning logins or data
            retrieval or access times.); Performance and behavioural data (For
            example, performance and behavioural data aspects such as
            performance evaluations, feedback from supervisors, training
            attendance, compliance with company policies, self-assessments, and
            behavioural assessments.); Working hours data (e.g. start of work
            time, end of work time, actual working hours, target working hours,
            break times, overtime, vacation days, special leave days, sick days,
            absences, home office days, business trips); Salary data (e.g. basic
            salary, bonus payments, premiums, tax class information, surcharges
            for night work/overtime, tax deductions, social security
            contributions, net payout amount); Images and/ or video recordings
            (e.g. photographs or video recordings of a person); Usage data (e.g.
            page views and duration of visit, click paths, intensity and
            frequency of use, types of devices and operating systems used,
            interactions with content and features). Meta, communication and
            process data (e.g. IP addresses, timestamps, identification numbers,
            involved parties).
          </li>
          <li>
            <strong>Special categories of personal data:</strong> Health Data;
            Religious or philosophical beliefs. Trade union membership.
          </li>
          <li>
            <strong>Data subjects:</strong> Employees (e.g. employees, job
            applicants, temporary workers, and other personnel.).
          </li>
          <li>
            <strong>Purposes of processing:</strong> Establishment and execution
            of employment relationships (Processing of employee data in the
            context of the establishment and execution of employment
            relationships); Business processes and management procedures;
            Provision of contractual services and fulfillment of contractual
            obligations; Public relations; Security measures. Office and
            organisational procedures.
          </li>
          <li className="">
            <strong>Legal Basis:</strong> Performance of a contract and prior
            requests (Article 6 (1) (b) GDPR); Compliance with a legal
            obligation (Article 6 (1) (c) GDPR); Legitimate Interests (Article 6
            (1) (f) GDPR). Healthcare, occupational and social security
            processing of special categories of personal data (Article 9 (2)(h)
            GDPR).
          </li>
        </ul>
        <p className="mb-4">
          <strong>
            Further information on processing methods, procedures and services
            used:
          </strong>
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index m-elements">
          <li>
            <strong>Time Recording: </strong>Processes for recording employees&apos;
            working hours include both manual and automated methods, such as the
            use of punch clocks, time tracking software, or mobile apps.
            Activities involved include entering clock-in and clock-out times,
            break times, overtime, and absences. To verify and validate the
            recorded working hours, they are compared with deployment or shift
            schedules, checked for absences, and approved for overtime by
            supervisors. Reports and analyses are generated based on the
            recorded working hours to provide work time records, overtime
            reports, and absence statistics for management and the human
            resources department;
            <span className="">
              <strong>Legal Basis:</strong> Performance of a contract and prior
              requests (Article 6 (1) (b) GDPR), Legitimate Interests (Article 6
              (1) (f) GDPR).
            </span>
          </li>
          <li>
            <strong>Authorization Management: </strong>Procedures required for
            the definition, management, and control of access rights and user
            roles within a system or an organisation (e.g., creation of
            authorisation profiles, role- and access-based control, review and
            approval of access requests, regular review of access rights,
            tracking and auditing of user activities, creation of security
            policies and procedures);
            <span className="">
              <strong>Legal Basis:</strong> Performance of a contract and prior
              requests (Article 6 (1) (b) GDPR), Compliance with a legal
              obligation (Article 6 (1) (c) GDPR), Legitimate Interests (Article
              6 (1) (f) GDPR).
            </span>
          </li>
          <li>
            <strong>Special categories of personal data: </strong>Special
            categories of personal data are processed in the context of
            employment relationships or to fulfil legal obligations. The
            processed special categories of personal data include information
            concerning the health, trade union membership, or religious
            affiliation of employees. This data may be transferred to health
            insurance companies or processed for assessing the employees&apos; work
            capacity, for corporate health management, or for declarations to
            the tax authorities;
            <span className="">
              <strong>Legal Basis:</strong> Performance of a contract and prior
              requests (Article 6 (1) (b) GDPR), Compliance with a legal
              obligation (Article 6 (1) (c) GDPR), Legitimate Interests (Article
              6 (1) (f) GDPR).
            </span>
          </li>
          <li>
            <strong>Sources of Processed Data: </strong>Personal data received
            during the application process and/or employment relationship will
            be processed. Furthermore, where required by law, personal data will
            be collected from other sources. These may include financial
            authorities for tax-related information, the respective health
            insurance company for information on work incapacity, third parties
            such as employment agencies, or publicly accessible sources like
            professional social networks in the context of application
            procedures;
            <span className="">
              <strong>Legal Basis:</strong> Compliance with a legal obligation
              (Article 6 (1) (c) GDPR), Legitimate Interests (Article 6 (1) (f)
              GDPR).
            </span>
          </li>
          <li>
            <strong>Purposes of Data Processing: </strong>The personal data of
            employees are primarily processed for the establishment, execution,
            and termination of the employment relationship. Furthermore, the
            processing of this data is necessary to fulfil legal obligations in
            the field of tax and social security law. In addition to these
            primary purposes, the data of employees are also used to meet
            regulatory and supervisory requirements, to optimise processes of
            electronic data processing, and to compile company-internal or
            cross-company data, possibly including statistical data. Moreover,
            the data of employees may be processed for the assertion of legal
            claims and defense in legal disputes;
            <span className="">
              <strong>Legal Basis:</strong> Performance of a contract and prior
              requests (Article 6 (1) (b) GDPR), Compliance with a legal
              obligation (Article 6 (1) (c) GDPR), Legitimate Interests (Article
              6 (1) (f) GDPR).
            </span>
          </li>
          <li>
            <strong>Transmission of Employee Data: </strong>The data of
            employees is processed internally only by those departments that
            require it to fulfil operational, contractual, and legal
            obligations. The transfer of data to external recipients only occurs
            if it is legally required, or if the affected employees have given
            their consent. Possible scenarios for this can include requests for
            information from authorities or in the case of asset formation
            benefits. Furthermore, the controller may transfer personal data to
            further recipients as far as this is necessary for fulfilling his
            contractual and legal obligations as an employer. These recipients
            can include: a) banks b) health insurance companies, pension
            insurance institutions, providers of old-age provisions and other
            social insurance carriers c) authorities, courts (e.g., tax
            authorities, labour courts, further supervisory authorities within
            the framework of fulfilling reporting and information obligations)
            d) tax and legal advisors e) third-party debtors in the case of wage
            and salary garnishments f) other entities to which legally
            obligatory declarations must be made.
            <br />
            In addition, data can be transferred to third parties if this is
            necessary for communication with business partners, suppliers or
            other service providers. Examples include details in the sender area
            of emails or letterheads as well as creating profiles on external
            platforms;
            <span className="">
              <strong>Legal Basis:</strong> Performance of a contract and prior
              requests (Article 6 (1) (b) GDPR), Legitimate Interests (Article 6
              (1) (f) GDPR).
            </span>
          </li>
          <li>
            <strong>Transmission of Employee Data to Third Countries: </strong>
            The transfer of employee data to third countries, meaning countries
            outside the European Union (EU) and the European Economic Area
            (EEA), occurs only if it is necessary for the fulfilment of the
            employment relationship, legally required, or if employees have
            given their consent. Employees will be informed about the details
            separately, as far as legally required;
            <span className="">
              <strong>Legal Basis:</strong> Legitimate Interests (Article 6 (1)
              (f) GDPR).
            </span>
          </li>
          <li>
            <strong>Business Travel and Travel Expense Settlement: </strong>
            Procedures required for planning, executing, and accounting for
            business trips (e.g., booking of travel, organizing accommodations
            and transportation, managing travel expense advances, submitting and
            reviewing travel expense reports, controlling and recording incurred
            costs, compliance with travel policies, handling of the travel
            expense management);
            <span className="">
              <strong>Legal Basis:</strong> Performance of a contract and prior
              requests (Article 6 (1) (b) GDPR), Compliance with a legal
              obligation (Article 6 (1) (c) GDPR), Legitimate Interests (Article
              6 (1) (f) GDPR).
            </span>
          </li>
          <li>
            <strong>Payroll and wage accounting: </strong>Procedures required
            for calculating, disbursing, and documenting wages, salaries, and
            other remuneration for employees (e.g., recording of working hours,
            calculation of deductions and surcharges, remittance of taxes and
            social security contributions, preparation of payroll statements,
            management of wage accounts, reporting to the tax authorities and
            social security institutions);
            <span className="">
              <strong>Legal Basis:</strong> Performance of a contract and prior
              requests (Article 6 (1) (b) GDPR), Compliance with a legal
              obligation (Article 6 (1) (c) GDPR).
            </span>
          </li>
          <li>
            <strong>Deletion of Employee Data: </strong>Employment data will be
            deleted under German law when it is no longer required for the
            purpose for which it was collected, unless there is a legal
            obligation to retain or archive it, or it needs to be kept for the
            interests of the employer. The following retention and archiving
            obligations are observed:
            <ul className="list-disc pl-6 space-y-2 mb-4 index list-disc pl-6 space-y-2 mb-4 index">
              
              <li>
                General personnel records - General personnel records (such as
                employment contracts, references, supplementary agreements) are
                retained for up to three years after the termination of the
                employment relationship (§ 195 German Civil Code (BGB)).
                <br />
                Tax-relevant documents - Tax-relevant documents in the personnel
                file are kept for six years (§ 147 Tax Code (AO), § 257
                Commercial Code (HGB)).
                <br />
                Information on wages and working hours - Information on wages
                and working hours for (accident) insured with wage proof are
                kept for five years (§ 165 I 1, IV 2 Social Code Book VII (SGB
                VII)).
              </li>
              <li>
                Payrolls including lists for special payments - Payrolls
                including lists for special payments, if a booking receipt is
                available, are kept for ten years (§ 147 Tax Code (AO), § 257
                Commercial Code (HGB)).
              </li>
              <li>
                Wage lists for interim, final, and special payments - Wage lists
                for interim, final, and special payments are kept for six years
                (§ 147 Tax Code (AO), § 257 Commercial Code (HGB)).
              </li>
              <li>
                Documents on employee insurance - Documents on employee
                insurance, if booking receipts are available, are kept for ten
                years (§ 147 Tax Code (AO), § 257 Commercial Code (HGB)).
              </li>
              <li>
                Contribution statements to social security institutions -
                Contribution statements to social security institutions are kept
                for ten years (§ 165 Social Code Book VII (SGB VII)).
                <br />
                Wage accounts - Wage accounts are kept for six years (§ 41 I 9
                Income Tax Act (EStG)).
              </li>
              <li>
                Applicant data - Kept for a maximum of six months from the
                receipt of rejection.
              </li>
              <li>
                Working time records (for more than 8 hours on workdays) - Kept
                for two years (§ 16 II Working Time Act (ArbZG)).
              </li>
              <li>
                Application documents (following online job advertisement) -
                Kept for three to a maximum of six months from the receipt of
                rejection (§ 26 Federal Data Protection Act (BDSG) n.F., § 15 IV
                General Act on Equal Treatment (AGG)).
              </li>
              <li>
                Certificates of incapacity for work (AU) - Kept for up to five
                years (§ 6 I Act on the Compensation of Expenses (AAG)).
              </li>
              <li>
                Documents on company pension schemes - Kept for 30 years (§ 18a
                Act to Improve Occupational Pensions (BetrAVG)).
              </li>
              <li>
                Sickness data of employees - Kept for twelve months from the
                start of the illness, if the absence in a year does not exceed
                six weeks.
              </li>
              <li>
                Documents on maternity protection - Kept for two years (§ 27
                para. 5 Maternity Protection Act (MuSchG)).
              </li>
            </ul>
            <span className="">
              <strong>Legal Basis:</strong> Performance of a contract and prior
              requests (Article 6 (1) (b) GDPR), Compliance with a legal
              obligation (Article 6 (1) (c) GDPR), Legitimate Interests (Article
              6 (1) (f) GDPR), Healthcare, occupational and social security
              processing of special categories of personal data (Article 9
              (2)(h) GDPR).
            </span>
          </li>
          <li>
            <strong>Personnel file management: </strong>Procedures required for
            the organisation, updating, and management of employee data and
            records (e.g., recording of basic personnel data, retention of
            employment contracts, certificates and attestations, updating data
            upon changes, compilation of documents for employee discussions,
            archiving of personnel files, compliance with data protection
            regulations);
            <span className="">
              <strong>Legal Basis:</strong> Performance of a contract and prior
              requests (Article 6 (1) (b) GDPR), Compliance with a legal
              obligation (Article 6 (1) (c) GDPR), Legitimate Interests (Article
              6 (1) (f) GDPR), Healthcare, occupational and social security
              processing of special categories of personal data (Article 9
              (2)(h) GDPR).
            </span>
          </li>
          <li>
            <strong>
              Personnel development, performance evaluation, and staff
              appraisals:
            </strong>
            Procedures required in the area of employee promotion and
            development, as well as in assessing their performance and during
            employee discussions (e.g., needs analysis for further training,
            planning and implementation of training measures, creation of
            performance evaluations, conducting goal-setting and feedback
            discussions, career planning and talent management, succession
            planning);
            <span className="">
              <strong>Legal Basis:</strong> Performance of a contract and prior
              requests (Article 6 (1) (b) GDPR), Compliance with a legal
              obligation (Article 6 (1) (c) GDPR), Legitimate Interests (Article
              6 (1) (f) GDPR), Healthcare, occupational and social security
              processing of special categories of personal data (Article 9
              (2)(h) GDPR).
            </span>
          </li>
          <li>
            <strong>Obligation to Provide Data: </strong>The person in charge
            informs the employees that the provision of their data is required.
            This is generally the case when the data are necessary for the
            establishment and execution of the employment relationship, or when
            their collection is mandated by law. The provision of data may also
            be required when employees assert claims or are entitled to claims.
            The implementation of these measures or fulfilment of services
            depends on the provision of such data (for example, providing data
            for the receipt of wages);
            <span className="">
              <strong>Legal Basis:</strong> Performance of a contract and prior
              requests (Article 6 (1) (b) GDPR), Compliance with a legal
              obligation (Article 6 (1) (c) GDPR), Legitimate Interests (Article
              6 (1) (f) GDPR).
            </span>
          </li>
          <li>
            <strong>Publication and Disclosure of Employee Data: </strong>The
            data of employees will only be published or disclosed to third
            parties if it is necessary for the performance of work tasks
            according to the employment contract. This applies, for example,
            when employees are named as contact persons in correspondences, on
            the website, or in public registers following an agreement or
            specified job description, or if their field of work includes
            representative functions. Similarly, this may occur if
            representation or communication with the public takes place as part
            of performing these tasks, such as image recordings during public
            relations activities. Otherwise, employee data is published only
            with their consent or based on the legitimate interests of the
            employer, for example, in the case of stage or group photographs
            taken during a public event;
            <span className="">
              <strong>Legal Basis:</strong> Performance of a contract and prior
              requests (Article 6 (1) (b) GDPR), Legitimate Interests (Article 6
              (1) (f) GDPR).
            </span>
          </li>
        </ul>
        <h2 className="text-2xl font-semibold mb-4" id="m15">Changes and Updates</h2>
        <p className="mb-4">
          We kindly ask you to inform yourself regularly about the contents of
          our data protection declaration. We will adjust the privacy policy as
          changes in our data processing practices make this necessary. We will
          inform you as soon as the changes require your cooperation (e.g.
          consent) or other individual notification.
        </p>
        <p className="mb-4">
          If we provide addresses and contact information of companies and
          organizations in this privacy policy, we ask you to note that
          addresses may change over time and to verify the information before
          contacting us.
        </p>
        <h2 className="text-2xl font-semibold mb-4" id="m42">Terminology and Definitions</h2>
        <p className="mb-4">
          In this section, you will find an overview of the terminology used in
          this privacy policy. Where the terminology is legally defined, their
          legal definitions apply. The following explanations, however, are
          primarily intended to aid understanding.
        </p>
        <ul className="list-disc pl-6 space-y-2 mb-4 index glossary">
          <li>
            <strong>A/B Tests:</strong> A/B tests are designed to improve the
            usability and performance of online services. For example, users are
            presented with different versions of a website or its elements, such
            as input forms, on which the placement of the contents or labels of
            the navigation elements can differ. The behaviour of users, e.g.
            prolonged visits to the site or more frequent interaction with the
            elements, can then be used to determine which of these sites or
            elements are more responsive to users&apos; needs.
          </li>
          <li>
            <strong>Affiliate Tracking:</strong> Custom Audiences refers to the
            process of determining target groups for advertising purposes, e.g.
            the display of advertisements. For example, a user&apos;s interest in
            certain products or topics on the Internet may be used to conclude
            that the user is interested in advertisements for similar products
            or the online store in which the user viewed the products.
            &quot;Lookalike Audiences&quot; is the term used to describe content that is
            viewed as suitable by users whose profiles or interests presumably
            correspond to the users for whom the profiles were created. For the
            purposes of creating custom audiences and lookalike audiences,
            cookies and web beacons are typically used.
          </li>
          <li>
            <strong>Artificial Intelligence (AI):</strong> The purpose of
            processing data through Artificial Intelligence (AI) includes the
            automated analysis and processing of user data to identify patterns,
            make predictions, and improve the efficiency and quality of our
            services. This involves the collection, cleansing, and structuring
            of data, training and applying AI models, as well as the continuous
            review and optimisation of results, and is carried out exclusively
            with users&apos; consent or based on legal authorisation grounds.
          </li>
          <li>
            <strong>Clicktracking:</strong> Clicktracking allows users to keep
            track of their movements within an entire website. Since the results
            of these tests are more accurate if the interaction of the users can
            be followed over a certain period of time (e.g. if a user likes to
            return), cookies are usually stored on the computers of the users
            for these test purposes.
          </li>
          <li>
            <strong>Contact data:</strong> Contact details are essential
            information that enables communication with individuals or
            organizations. They include, among others, phone numbers, postal
            addresses, and email addresses, as well as means of communication
            like social media handles and instant messaging identifiers.
          </li>
          <li>
            <strong>Content data:</strong> Content data comprise information
            generated in the process of creating, editing, and publishing
            content of all types. This category of data may include texts,
            images, videos, audio files, and other multimedia content published
            across various platforms and media. Content data are not limited to
            the content itself but also include metadata providing information
            about the content, such as tags, descriptions, authorship details,
            and publication dates.
          </li>
          <li>
            <strong>Contract data:</strong> Contract data are specific details
            pertaining to the formalisation of an agreement between two or more
            parties. They document the terms under which services or products
            are provided, exchanged, or sold. This category of data is essential
            for managing and fulfilling contractual obligations and includes
            both the identification of the contracting parties and the specific
            terms and conditions of the agreement. Contract data may encompass
            the start and end dates of the contract, the nature of the
            agreed-upon services or products, pricing arrangements, payment
            terms, termination rights, extension options, and special conditions
            or clauses. They serve as the legal foundation for the relationship
            between the parties and are crucial for clarifying rights and
            duties, enforcing claims, and resolving disputes.
          </li>
          <li>
            <strong>Controller:</strong> &quot;Controller&quot; means the natural or legal
            person, public authority, agency or other body which, alone or
            jointly with others, determines the purposes and means of the
            processing of personal data.
          </li>
          <li>
            <strong>Conversion tracking:</strong> Conversion tracking is a
            method used to evaluate the effectiveness of marketing measures. For
            this purpose, a cookie is usually stored on the devices of the users
            within the websites on which the marketing measures take place and
            then called up again on the target website (e.g. we can thus trace
            whether the advertisements placed by us on other websites were
            successful).
          </li>
          <li>
            <strong>Employees:</strong> As employees, individuals are those who
            are engaged in an employment relationship, whether as staff,
            employees, or in similar positions. Employment refers to a legal
            relationship between an employer and an employee, established
            through an employment contract or agreement. It entails the
            obligation of the employer to pay the employee remuneration while
            the employee performs their work. The employment relationship
            encompasses various stages, including establishment, where the
            employment contract is concluded, execution, where the employee
            carries out their work activities, and termination, when the
            employment relationship ends, whether through termination, mutual
            agreement, or otherwise. Employee data encompasses all information
            pertaining to these individuals within the context of their
            employment. This includes aspects such as personal identification
            details, identification numbers, salary and banking information,
            working hours, holiday entitlements, health data, and performance
            assessments.
          </li>
          <li>
            <strong>Heatmaps:</strong> &quot;Heatmaps&quot; are mouse movements of the
            users, which are combined to an overall picture, with the help of
            which it can be recognized, for example, which web page elements are
            preferred and which web page elements users prefer less.
          </li>
          <li>
            <strong>Inventory data:</strong> Inventory data encompass essential
            information required for the identification and management of
            contractual partners, user accounts, profiles, and similar
            assignments. These data may include, among others, personal and
            demographic details such as names, contact information (addresses,
            phone numbers, email addresses), birth dates, and specific
            identifiers (user IDs). Inventory data form the foundation for any
            formal interaction between individuals and services, facilities, or
            systems, by enabling unique assignment and communication.
          </li>
          <li>
            <strong>Log data:</strong> Protocol data, or log data, refer to
            information regarding events or activities that have been logged
            within a system or network. These data typically include details
            such as timestamps, IP addresses, user actions, error messages, and
            other specifics about the usage or operation of a system. Protocol
            data is often used for analyzing system issues, monitoring security,
            or generating performance reports.
          </li>
          <li>
            <strong>Meta, communication and process data:</strong> Meta-,
            communication, and procedural data are categories that contain
            information about how data is processed, transmitted, and managed.
            Meta-data, also known as data about data, include information that
            describes the context, origin, and structure of other data. They can
            include details about file size, creation date, the author of a
            document, and modification histories. Communication data capture the
            exchange of information between users across various channels, such
            as email traffic, call logs, messages in social networks, and chat
            histories, including the involved parties, timestamps, and
            transmission paths. Procedural data describe the processes and
            operations within systems or organisations, including workflow
            documentations, logs of transactions and activities, and audit logs
            used for tracking and verifying procedures.
          </li>
          <li>
            <strong>Payment Data:</strong> Payment data comprise all information
            necessary for processing payment transactions between buyers and
            sellers. This data is crucial for e-commerce, online banking, and
            any other form of financial transaction. It includes details such as
            credit card numbers, bank account information, payment amounts,
            transaction dates, verification numbers, and billing information.
            Payment data may also contain information on payment status,
            chargebacks, authorizations, and fees.
          </li>
          <li>
            <strong>Performance and behavioural data:</strong>
            Performance and behavioral data refer to information related to how
            individuals perform tasks or behave within a certain context, such
            as in an educational, work, or social setting. This data may include
            metrics such as productivity, efficiency, quality of work,
            attendance, and adherence to policies or procedures. Behavioral data
            could encompass interactions with colleagues, communication styles,
            decision-making processes, and responses to various situations.
            These types of data are often used for performance evaluations,
            training and development purposes, and decision-making within
            organizations.
          </li>
          <li>
            <strong>Personal Data:</strong> &quot;personal data&quot; means any
            information relating to an identified or identifiable natural person
            (&quot;data subject&quot;); an identifiable natural person is one who can be
            identified, directly or indirectly, in particular by reference to an
            identifier such as a name, an identification number, location data,
            an online identifier or to one or more factors specific to the
            physical, physiological, genetic, mental, economic, cultural or
            social identity of that natural person.
          </li>
          <li>
            <strong>Processing:</strong> The term &quot;processing&quot; covers a wide
            range and practically every handling of data, be it collection,
            evaluation, storage, transmission or erasure.
          </li>
          <li>
            <strong>Profiles with user-related information:</strong> The
            processing of &quot;profiles with user-related information&quot;, or
            &quot;profiles&quot; for short, includes any kind of automated processing of
            personal data that consists of using these personal data to analyse,
            evaluate or predict certain personal aspects relating to a natural
            person (depending on the type of profiling, this may include
            different information concerning demographics, behaviour and
            interests, such as interaction with websites and their content,
            etc.) (e.g. interests in certain content or products, click
            behaviour on a website or location). Cookies and web beacons are
            often used for profiling purposes.
          </li>
          <li>
            <strong>Remarketing:</strong> Remarketing&quot; or &quot;retargeting&quot; is the
            term used, for example, to indicate for advertising purposes which
            products a user is interested in on a website in order to remind the
            user of these products on other websites, e.g. in advertisements.
          </li>
          <li>
            <strong>Targeting:</strong> &quot;Tracking&quot; is the term used when the
            behaviour of users can be traced across several websites. As a rule,
            behavior and interest information with regard to the websites used
            is stored in cookies or on the servers of the tracking technology
            providers (so-called profiling). This information can then be used,
            for example, to display advertisements to users presumably
            corresponding to their interests.
          </li>
          <li>
            <strong>Usage data:</strong> Usage data refer to information that
            captures how users interact with digital products, services, or
            platforms. These data encompass a wide range of information that
            demonstrates how users utilise applications, which features they
            prefer, how long they spend on specific pages, and through what
            paths they navigate an application. Usage data can also include the
            frequency of use, timestamps of activities, IP addresses, device
            information, and location data. They are particularly valuable for
            analysing user behaviour, optimising user experiences, personalising
            content, and improving products or services. Furthermore, usage data
            play a crucial role in identifying trends, preferences, and
            potential problem areas within digital offerings
          </li>
          <li>
            <strong>Web Analytics:</strong> Web Analytics serves the evaluation
            of visitor traffic of online services and can determine their
            behavior or interests in certain information, such as content of
            websites. With the help of web analytics, website owners, for
            example, can recognize at what time visitors visit their website and
            what content they are interested in. This enables them, for example,
            to better adapt the content of their websites to the needs of their
            visitors. For the purposes of web analytics , pseudonymous cookies
            and web beacons are often used to recognize returning visitors and
            thus obtain more precise analyses of the use of an online service.
          </li>
        </ul>
      </div>
    </Section>
  );
}
